export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  GraphQLDate: { input: string; output: string };
  GraphQLDateTime: { input: string; output: string };
  GraphQLTimeZone: { input: unknown; output: unknown };
  GraphQLUUID: { input: unknown; output: unknown };
};

export enum ActivityDeviceType {
  AppleWatch = 'APPLE_WATCH',
  Phone = 'PHONE',
  Watch = 'WATCH',
}

export enum ActivitySourceDevice {
  Fitbit = 'FITBIT',
  Googlefit = 'GOOGLEFIT',
  Healthconnect = 'HEALTHCONNECT',
  Healthkit = 'HEALTHKIT',
  Manual = 'MANUAL',
  None = 'NONE',
}

/** Legacy type from ChallengeListItem, deprecated */
export type ActivityTrackingDailyTotal = {
  __typename: 'ActivityTrackingDailyTotal';
  date?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tracked: Scalars['Int']['output'];
};

export type AnswerAssessmentQuestionsInput = {
  answers?: InputMaybe<Array<InputMaybe<AssessmentAnswersInput>>>;
  requestGlobalContent?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

export type AnswerAssessmentQuestionsResponse = {
  __typename: 'AnswerAssessmentQuestionsResponse';
  assessment?: Maybe<AssessmentListItem>;
  originalTierState?: Maybe<AssessmentItemCurrentTierProgress>;
  tierProgressPointsDifference?: Maybe<Scalars['Int']['output']>;
};

/** This can be extended in future to support additional question types */
export type AnswerPreAssessmentInput = {
  careAssessmentId: Scalars['ID']['input'];
  choiceAnswers?: InputMaybe<Array<CareAssessmentChoiceAnswer>>;
  freeTextAnswers?: InputMaybe<Array<CareAssessmentFreeTextAnswer>>;
  /** Optional, used when responses are part of a retake session */
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerPreAssessmentResponse = {
  __typename: 'AnswerPreAssessmentResponse';
  /** The next assessment in the pre assessment sequence. Null if there are no more asseessments remaining for pre assessment. */
  nextAssessment?: Maybe<CareAssessment>;
  /** The recommended action the user should take at this point in the pre assessment process. Based on the users current pre assessment progress. */
  recommendation?: Maybe<PreAssessmentRecommendation>;
  /** Score results. Non-null when the score screen needs to be displayed at the end. Is expected that `nextAssessment` is null at this point. */
  results?: Maybe<PreAssessmentResults>;
};

export type Appointment = {
  __typename: 'Appointment';
  allowsCancellation: Scalars['Boolean']['output'];
  counsellor: Counsellor;
  endDateTime: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ID']['output'];
  isVisibleToUser: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  startDateTime: Scalars['GraphQLDateTime']['output'];
  status: AppointmentStatus;
  typeDescription: AppointmentType;
};

export type AppointmentPaymentSetupIntentResponse = {
  __typename: 'AppointmentPaymentSetupIntentResponse';
  stripeIntent: StripeSetupIntent;
};

export enum AppointmentStatus {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export enum AppointmentType {
  InPerson = 'IN_PERSON',
  PhoneCall = 'PHONE_CALL',
  VideoCall = 'VIDEO_CALL',
}

export type AppointmentsDateTimeFilter = {
  from?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  to?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

/**
 * `Article` is a shared type used by both Assessments API and Digital Clinical Programs API (CareNow).
 * It contains a superset of the fields that may be present in each usage of the type in the schema.
 * However, only `contentItemId`, `title` and `body` will be resolved from assessments-api.
 * **As a consequence, `Article` fields not provided by assessments-api will always resolve as `null`**, see:
 * [Apollo docs - Solutions for unresolvable fields](https://www.apollographql.com/docs/graphos/schema-design/federated-schemas/reference/composition-rules#solutions-for-unresolvable-fields)
 * It may be better to split these types at some point or redefine them as Entities.
 */
export type Article = {
  __typename: 'Article';
  /** `audios` will always return `null` as part of the `totalHealthIndexResult` query */
  audios?: Maybe<Array<ArticleAudio>>;
  /** `author` will always return `null` as part of the `totalHealthIndexResult` query */
  author?: Maybe<ArticleAuthor>;
  body: Scalars['String']['output'];
  /** `categoryTitle` will always return `null` as part of the `totalHealthIndexResult` query */
  categoryTitle?: Maybe<Scalars['String']['output']>;
  contentItemId: Scalars['ID']['output'];
  /** `heroImage` will always return `null` as part of the `totalHealthIndexResult` query */
  heroImage?: Maybe<Image>;
  /** `lastModificationDate` will always return `null` as part of the `totalHealthIndexResult` query */
  lastModificationDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  title: Scalars['String']['output'];
  /** `url` will always return `null` as part of the `totalHealthIndexResult` query */
  url?: Maybe<Scalars['String']['output']>;
  /** `userInteraction` will always return `null` as part of the `totalHealthIndexResult` query */
  userInteraction?: Maybe<ArticleInteraction>;
  /** `videos` will always return `null` as part of the `totalHealthIndexResult` query */
  videos?: Maybe<Array<ArticleVideo>>;
};

export type ArticleAudio = {
  __typename: 'ArticleAudio';
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type ArticleAuthor = {
  __typename: 'ArticleAuthor';
  image?: Maybe<Image>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  surname: Scalars['String']['output'];
};

export type ArticleDocument = {
  __typename: 'ArticleDocument';
  copyright?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  pages?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  size: Scalars['String']['output'];
  thumbnail?: Maybe<Image>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ArticleInteraction = {
  __typename: 'ArticleInteraction';
  seenByUser: Scalars['Boolean']['output'];
};

export type ArticleInteractionInput = {
  contentItemId: Scalars['ID']['input'];
  seenByUser: Scalars['Boolean']['input'];
};

export enum ArticleType {
  Audio = 'AUDIO',
  Journal = 'JOURNAL',
  Text = 'TEXT',
  Video = 'VIDEO',
}

export type ArticleVideo = {
  __typename: 'ArticleVideo';
  /** If `hlsUrl` is not provided the client should fall back to `url` */
  hlsUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AskForImmediateHelpResponse = {
  __typename: 'AskForImmediateHelpResponse';
  ccsTeamTelephoneNumber: Scalars['String']['output'];
};

export type AssessedAsSuicideRiskResponse = {
  __typename: 'AssessedAsSuicideRiskResponse';
  ccsTeamTelephoneNumber: Scalars['String']['output'];
};

export type AssessmentAnswersInput = {
  measurements?: InputMaybe<
    Array<InputMaybe<AssessmentAnswersMeasurementsInput>>
  >;
  optionUuids?: InputMaybe<Array<Scalars['ID']['input']>>;
  questionUuid: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AssessmentAnswersMeasurementsInput = {
  calculationType?: InputMaybe<Scalars['String']['input']>;
  measurementType?: InputMaybe<Scalars['String']['input']>;
  measurementUuid: Scalars['ID']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum AssessmentCategory {
  Biometric = 'BIOMETRIC',
  Financial = 'FINANCIAL',
  Health = 'HEALTH',
  Lifestyle = 'LIFESTYLE',
  Other = 'OTHER',
  Thi = 'THI',
}

export type AssessmentContentCategory = {
  __typename: 'AssessmentContentCategory';
  title: Scalars['String']['output'];
};

export type AssessmentContentMeasurementResult = {
  __typename: 'AssessmentContentMeasurementResult';
  feedback?: Maybe<MeasurementResultFeedback>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type AssessmentContentStats = {
  __typename: 'AssessmentContentStats';
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type AssessmentContentType = {
  __typename: 'AssessmentContentType';
  description?: Maybe<Scalars['String']['output']>;
  handleUuid?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  typeGroup?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export enum AssessmentGroupType {
  Hra = 'HRA',
  Thi = 'THI',
}

export type AssessmentHeroCard =
  HealthRiskAssessmentCard | SingleAssessmentCard | TotalHealthIndexCard;

export type AssessmentItemAnswers = {
  __typename: 'AssessmentItemAnswers';
  measurements?: Maybe<Array<Maybe<AssessmentItemAnswersMeasurements>>>;
  optionUuids?: Maybe<Array<Scalars['ID']['output']>>;
  questionUuid: Scalars['ID']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type AssessmentItemAnswersMeasurements = {
  __typename: 'AssessmentItemAnswersMeasurements';
  calculationType?: Maybe<Scalars['String']['output']>;
  measurementType?: Maybe<Scalars['String']['output']>;
  measurementUuid: Scalars['ID']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AssessmentItemContentAuthor = {
  __typename: 'AssessmentItemContentAuthor';
  bio?: Maybe<Scalars['String']['output']>;
  images?: Maybe<AssessmentItemContentImages>;
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type AssessmentItemContentImages = {
  __typename: 'AssessmentItemContentImages';
  articleinline?: Maybe<Scalars['String']['output']>;
  articlethumbnail?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  documentlandscape?: Maybe<Scalars['String']['output']>;
  documentportrait?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
};

export type AssessmentItemCurrentTierProgress = {
  __typename: 'AssessmentItemCurrentTierProgress';
  bonusPointsForCompletingAllAssessments?: Maybe<Scalars['Int']['output']>;
  pointsForCompletingAssessment?: Maybe<Scalars['Int']['output']>;
  tierSummary?: Maybe<CurrentTierProgressSummary>;
};

export type AssessmentItemHistory = {
  __typename: 'AssessmentItemHistory';
  archiveId: Scalars['ID']['output'];
  assessmentUuid: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  cooldownPeriodExpirationDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  introduction: Scalars['String']['output'];
  numberOfQuestions: Scalars['Int']['output'];
  result?: Maybe<AssessmentItemHistoryResult>;
  title: Scalars['String']['output'];
};

export type AssessmentItemHistoryResult = {
  __typename: 'AssessmentItemHistoryResult';
  digest?: Maybe<Scalars['String']['output']>;
  digestTitle: Scalars['String']['output'];
  maxScaleLabel?: Maybe<Scalars['String']['output']>;
  minScaleLabel?: Maybe<Scalars['String']['output']>;
  percentageScore?: Maybe<Scalars['Float']['output']>;
  shouldDisplayPercentage?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentItemQuestionnaire = {
  __typename: 'AssessmentItemQuestionnaire';
  introduction: Scalars['String']['output'];
  measurements?: Maybe<Array<Maybe<AssessmentItemQuestionnaireMeasurements>>>;
  multipleChoice?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<AssessmentItemQuestionnaireOptionsList>>>;
  questionType?: Maybe<QuestionnaireQuestionType>;
  reference?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type AssessmentItemQuestionnaireMeasurementRanges = {
  __typename: 'AssessmentItemQuestionnaireMeasurementRanges';
  label?: Maybe<Scalars['String']['output']>;
  ranges?: Maybe<Array<MeasurementRanges>>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type AssessmentItemQuestionnaireMeasurements = {
  __typename: 'AssessmentItemQuestionnaireMeasurements';
  calculationType?: Maybe<Scalars['String']['output']>;
  measurementRanges?: Maybe<
    Array<Maybe<AssessmentItemQuestionnaireMeasurementRanges>>
  >;
  unitOfMeasurement?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type AssessmentItemQuestionnaireOptionAlert = {
  __typename: 'AssessmentItemQuestionnaireOptionAlert';
  message?: Maybe<Scalars['String']['output']>;
};

export type AssessmentItemQuestionnaireOptionsList = {
  __typename: 'AssessmentItemQuestionnaireOptionsList';
  alert?: Maybe<AssessmentItemQuestionnaireOptionAlert>;
  jumpTo?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['ID']['output'];
};

export type AssessmentListItem = {
  __typename: 'AssessmentListItem';
  answers?: Maybe<Array<Maybe<AssessmentItemAnswers>>>;
  canBeRetaken?: Maybe<Scalars['Boolean']['output']>;
  cooldownPeriodExpirationDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  history?: Maybe<Array<Maybe<AssessmentItemHistory>>>;
  icon?: Maybe<Image>;
  introduction: Scalars['String']['output'];
  lastUpdatedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  localisedUuid: Scalars['ID']['output'];
  nextAssessment?: Maybe<AssessmentListItem>;
  nextQuestionReference?: Maybe<Scalars['String']['output']>;
  numberOfQuestions: Scalars['Int']['output'];
  percentageComplete: Scalars['Float']['output'];
  questionnaire?: Maybe<Array<Maybe<AssessmentItemQuestionnaire>>>;
  remainingAssessmentsCompletionPoints?: Maybe<RemainingAssessmentsCompletionPoints>;
  result?: Maybe<AssessmentListItemResult>;
  status: AssessmentStatus;
  tierPoints?: Maybe<Scalars['Int']['output']>;
  tierProgress?: Maybe<AssessmentItemCurrentTierProgress>;
  title: Scalars['String']['output'];
  type: AssessmentType;
  uuid: Scalars['ID']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type AssessmentListItemResult = {
  __typename: 'AssessmentListItemResult';
  content?: Maybe<Array<Maybe<AssessmentListItemResultContentList>>>;
  digest?: Maybe<Scalars['String']['output']>;
  digestTitle: Scalars['String']['output'];
  feedback?: Maybe<Array<Maybe<ResultFeedback>>>;
  gender?: Maybe<Scalars['String']['output']>;
  maxScaleLabel: Scalars['String']['output'];
  maxScore?: Maybe<Scalars['Int']['output']>;
  measurementResult?: Maybe<AssessmentContentMeasurementResult>;
  minScaleLabel: Scalars['String']['output'];
  minScore?: Maybe<Scalars['Int']['output']>;
  percentageScore: Scalars['Float']['output'];
  score: Scalars['Int']['output'];
  shouldDisplayPercentage?: Maybe<Scalars['Boolean']['output']>;
};

export type AssessmentListItemResultContentList = {
  __typename: 'AssessmentListItemResultContentList';
  author?: Maybe<AssessmentItemContentAuthor>;
  category?: Maybe<AssessmentContentCategory>;
  handleUuid?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<AssessmentItemContentImages>;
  lastModificationDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  resourcePath?: Maybe<Scalars['String']['output']>;
  sanitizedBody?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<AssessmentContentStats>;
  thumbnail?: Maybe<Image>;
  title: Scalars['String']['output'];
  translationLocale?: Maybe<Scalars['String']['output']>;
  translationUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AssessmentContentType>;
  uri?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type AssessmentPromotion = {
  __typename: 'AssessmentPromotion';
  assessment?: Maybe<AssessmentListItem>;
  externalId: Scalars['ID']['output'];
  icon?: Maybe<Image>;
  image?: Maybe<Image>;
  message?: Maybe<Scalars['String']['output']>;
  promotionType?: Maybe<PromotionType>;
  schedule?: Maybe<WellbeingPromotionSchedule>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum AssessmentStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
}

export type AssessmentTierPoints = {
  __typename: 'AssessmentTierPoints';
  assessmentCooldownFrequency?: Maybe<Scalars['String']['output']>;
  pointsForAnAssessment?: Maybe<Scalars['Int']['output']>;
  pointsForHRA?: Maybe<Scalars['Int']['output']>;
  pointsForTHI?: Maybe<Scalars['Int']['output']>;
  userHasTieringEnabled: Scalars['Boolean']['output'];
};

export type AssessmentType = {
  __typename: 'AssessmentType';
  description?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AssessmentTypeFilter = {
  __typename: 'AssessmentTypeFilter';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  typeId: Scalars['String']['output'];
};

export type AssignCarePlanInput = {
  carePlanId: Scalars['ID']['input'];
};

export type AssignCarePlanResponse = {
  __typename: 'AssignCarePlanResponse';
  received: Scalars['Boolean']['output'];
};

export type AvailableCarePlansInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailableCarePlansResponse = {
  __typename: 'AvailableCarePlansResponse';
  carePlans: PaginatedCarePlans;
};

export type AvailableMoodFactorsResponse = {
  __typename: 'AvailableMoodFactorsResponse';
  factors: Array<MoodFactor>;
};

export type AvailableTimeSlot = {
  __typename: 'AvailableTimeSlot';
  counsellor: Counsellor;
  endDateTime: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ID']['output'];
  startDateTime: Scalars['GraphQLDateTime']['output'];
  types: Array<AppointmentType>;
};

export type AverageDailyMoodInsightsInput = {
  from?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type AverageDailyMoodInsightsResponse = {
  __typename: 'AverageDailyMoodInsightsResponse';
  data: Array<DailyMoodDataPoint>;
  message: Scalars['String']['output'];
  /** Number of entries taken into account to compute the data points. */
  sampleSize: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type AverageSteps = EndOfChallengeSummaryTotal & {
  __typename: 'AverageSteps';
  total: Scalars['Int']['output'];
};

export type Banner = {
  __typename: 'Banner';
  dismissed: Scalars['Boolean']['output'];
  id: BannerId;
};

/** Banner logic and content differs from tooltips hence the separate types */
export enum BannerId {
  /** Used to show a tooltip to highlight the ccs chat button on the toolbar, shown once per user */
  CcsChat = 'CCS_CHAT',
  /** Shown once to highlight what's new in Copilot */
  CopilotWhatsNew = 'COPILOT_WHATS_NEW',
  WelcomeToMyCare = 'WELCOME_TO_MY_CARE',
}

export type BannerInput = {
  id: BannerId;
};

export type BannerResponse = {
  __typename: 'BannerResponse';
  banner: Banner;
};

export type BenefitPlan = {
  __typename: 'BenefitPlan';
  choices?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type BenefitsSummary = {
  __typename: 'BenefitsSummary';
  plans?: Maybe<Array<BenefitPlan>>;
  portalUrlId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totals?: Maybe<Array<PensionAndBenefitsTotal>>;
};

export type BookAppointmentInput = {
  /** User's date of birth, optional for backwards compatibility */
  dateOfBirth?: InputMaybe<Scalars['GraphQLDate']['input']>;
  email: Scalars['String']['input'];
  isVoicemailPreferred: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
  timeSlotId: Scalars['ID']['input'];
  /** `IN_PERSON` will fail */
  type: AppointmentType;
};

export type BookAppointmentResponse = {
  __typename: 'BookAppointmentResponse';
  appointment: Appointment;
};

export type CancelAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
};

export type CancelAppointmentResponse = {
  __typename: 'CancelAppointmentResponse';
  appointment: Appointment;
};

/**
 * This enum should be mapped to the card brand fetch from Stripe and should be always maintained up to date
 * with all the supported brands
 */
export enum CardBrand {
  Amex = 'AMEX',
  CartesBancaires = 'CARTES_BANCAIRES',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  UnionPay = 'UNION_PAY',
  Visa = 'VISA',
}

export type CareAssessment = {
  __typename: 'CareAssessment';
  /** A unique identifier for the assessment. Is also used for tracking in google analytics. */
  id: Scalars['ID']['output'];
  /**
   * The list of questions that make up the assessment.
   * The first question in the array is the first question to be asked.
   * Subsequent questions are asked based on the option the user selects.
   */
  questions: Array<CareAssessmentQuestion>;
  /** A unique value that is used to track and group responses when Care Assessments are retaken */
  sessionId?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CareAssessmentChoiceAnswer = {
  optionId: Scalars['ID']['input'];
};

export type CareAssessmentChoiceQuestion = {
  __typename: 'CareAssessmentChoiceQuestion';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options: Array<CareAssessmentChoiceQuestionOption>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CareAssessmentChoiceQuestionOption = {
  __typename: 'CareAssessmentChoiceQuestionOption';
  id: Scalars['ID']['output'];
  /**
   * If the user answers with this option then skip to the question with the specified id.
   * If null then there are no more questions for the user to answer.
   */
  nextQuestionId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type CareAssessmentFreeTextAnswer = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** This union is to support multiple Question types. */
export type CareAssessmentQuestion =
  CareAssessmentChoiceQuestion | CareAssessmentTextQuestion;

export type CareAssessmentTextQuestion = {
  __typename: 'CareAssessmentTextQuestion';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maxLength: Scalars['Int']['output'];
  /**
   * The question that user should do next.
   * If null, then there are no more questions for the user to answer.
   */
  nextQuestionId?: Maybe<Scalars['ID']['output']>;
  /** Localised text that prompts user on what data to input */
  placeholder?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/**
 * CareIssue is a type used to represent a health & wellbeing issue the user might want to focus on.
 * This will influence their care plan and pre assessment.
 */
export type CareIssue = {
  __typename: 'CareIssue';
  analyticsId: Scalars['String']['output'];
  /** The CareIssue that will be recommended to users that do not yet know what to work on */
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  selected?: Maybe<Scalars['Boolean']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CareIssuesResponse = {
  __typename: 'CareIssuesResponse';
  careIssues: Array<CareIssue>;
};

export type CarePlan = {
  __typename: 'CarePlan';
  currentActivity?: Maybe<CarePlanActivity>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sections: Array<CarePlanSection>;
};

export type CarePlanActivity = {
  completed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  module: CarePlanModule;
  nextActivity?: Maybe<CarePlanActivity>;
  previousActivity?: Maybe<CarePlanActivity>;
  title: Scalars['String']['output'];
};

export type CarePlanActivityArticle = CarePlanActivity & {
  __typename: 'CarePlanActivityArticle';
  audios: Array<ArticleAudio>;
  body: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  copyright: Scalars['String']['output'];
  documents: Array<ArticleDocument>;
  heroImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  module: CarePlanModule;
  nextActivity?: Maybe<CarePlanActivity>;
  previousActivity?: Maybe<CarePlanActivity>;
  title: Scalars['String']['output'];
  type?: Maybe<ArticleType>;
  url: Scalars['String']['output'];
  videos: Array<ArticleVideo>;
};

export type CarePlanActivityInput = {
  id: Scalars['ID']['input'];
};

export type CarePlanActivityResponse = {
  __typename: 'CarePlanActivityResponse';
  carePlanActivity?: Maybe<CarePlanActivity>;
};

export type CarePlanModule = {
  __typename: 'CarePlanModule';
  activities: Array<CarePlanActivity>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CarePlanResponse = {
  __typename: 'CarePlanResponse';
  carePlan?: Maybe<CarePlan>;
};

export type CarePlanSection = {
  __typename: 'CarePlanSection';
  id: Scalars['ID']['output'];
  modules: Array<CarePlanModule>;
};

/** Defines the available options to get Care Service for a user during onboarding. */
export enum CareServiceOption {
  /** User preference to use Counselling support. */
  CounsellorSupport = 'COUNSELLOR_SUPPORT',
  /** User preference to use self care via Care Plans. */
  SelfCare = 'SELF_CARE',
}

export type CashbackOffer = Offer & {
  __typename: 'CashbackOffer';
  /** Only relevant for "coupons" */
  code?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  merchant: Merchant;
  rate?: Maybe<CashbackRate>;
  /** Only relevant for "rates" */
  rateType?: Maybe<CashbackOfferRateType>;
  title: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum CashbackOfferRateType {
  Special = 'SPECIAL',
  Standard = 'STANDARD',
}

export type CashbackRate = CashbackRateFixAmount | CashbackRatePercentage;

export type CashbackRateFixAmount = {
  __typename: 'CashbackRateFixAmount';
  amount?: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
};

export type CashbackRatePercentage = {
  __typename: 'CashbackRatePercentage';
  amount?: Maybe<Scalars['Float']['output']>;
};

/**
 * A union to support different challenge
 * types based on the challengeType field.
 * Source: challenge-api
 */
export type Challenge = HabitChallenge | StepChallenge;

export enum ChallengeActivityStatus {
  /** Selectable — backed by a real challenge template */
  Available = 'Available',
  /** Rendered but not selectable — no template behind it yet */
  ComingSoon = 'ComingSoon',
}

export type ChallengeActivityTracking = {
  __typename: 'ChallengeActivityTracking';
  category: ChallengeActivityTrackingCategory;
  permissions?: Maybe<ChallengeActivityTrackingPermissions>;
  startTime: Scalars['GraphQLDateTime']['output'];
  type: ChallengeType;
};

export enum ChallengeActivityTrackingCategory {
  Automatic = 'Automatic',
  Manual = 'Manual',
}

export type ChallengeActivityTrackingPermission = {
  __typename: 'ChallengeActivityTrackingPermission';
  isMandatory: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type ChallengeActivityTrackingPermissions = {
  __typename: 'ChallengeActivityTrackingPermissions';
  askUser?: Maybe<ChallengeActivityTrackingPermissionsAskUser>;
  required?: Maybe<Array<Maybe<ChallengeActivityTrackingPermission>>>;
};

export type ChallengeActivityTrackingPermissionsAskUser = {
  __typename: 'ChallengeActivityTrackingPermissionsAskUser';
  info: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum ChallengeActivityType {
  Cycling = 'Cycling',
  Gym = 'Gym',
  Run = 'Run',
  Stand = 'Stand',
  Stretch = 'Stretch',
  Swimming = 'Swimming',
  Walk = 'Walk',
  Yoga = 'Yoga',
}

export type ChallengeActivityTypeOption = {
  __typename: 'ChallengeActivityTypeOption';
  /** Unicode emoji shown before the label — not localised */
  emoji: Scalars['String']['output'];
  label: Scalars['String']['output'];
  status: ChallengeActivityStatus;
  value: ChallengeActivityType;
};

export enum ChallengeCategory {
  HabitSwitching = 'HabitSwitching',
  Mental = 'Mental',
  Physical = 'Physical',
}

export type ChallengeDailyReward = {
  __typename: 'ChallengeDailyReward';
  pointsEarned: Scalars['Int']['output'];
  pointsPotential: Scalars['Int']['output'];
};

export type ChallengeHabits = {
  __typename: 'ChallengeHabits';
  editSelectedHabits: EditSelectedHabitsCaption;
  habits: Array<Habit>;
  selectHabit: SelectHabitCaption;
};

export type ChallengeIntroduction = {
  __typename: 'ChallengeIntroduction';
  id: Scalars['String']['output'];
  info: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ChallengeParticipant = {
  __typename: 'ChallengeParticipant';
  fullName: Scalars['String']['output'];
  image?: Maybe<Image>;
  status?: Maybe<ChallengeStatus>;
  userId: Scalars['ID']['output'];
};

export type ChallengeParticipantLeaderboardEntry = {
  __typename: 'ChallengeParticipantLeaderboardEntry';
  participant?: Maybe<ChallengeParticipant>;
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['String']['output']>;
};

export enum ChallengeParticipationType {
  Corporate = 'Corporate',
  Custom = 'Custom',
  Individual = 'Individual',
}

export type ChallengePromotion = {
  __typename: 'ChallengePromotion';
  challengeUnion?: Maybe<Challenge>;
  externalId: Scalars['ID']['output'];
  icon?: Maybe<Image>;
  image?: Maybe<Image>;
  message?: Maybe<Scalars['String']['output']>;
  promotionType?: Maybe<PromotionType>;
  schedule?: Maybe<WellbeingPromotionSchedule>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ChallengeResult = {
  __typename: 'ChallengeResult';
  newTier?: Maybe<Tier>;
  pointsAwarded?: Maybe<Scalars['Int']['output']>;
  tieringStatus: ChallengeResultTieringStatus;
};

export enum ChallengeResultTieringStatus {
  NotEnabled = 'NOT_ENABLED',
  NoPointsAwarded = 'NO_POINTS_AWARDED',
  PointsAwarded = 'POINTS_AWARDED',
  Promoted = 'PROMOTED',
}

export enum ChallengeStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Succeeded = 'Succeeded',
}

export type ChallengeTeamsLeaderboardEntry = {
  __typename: 'ChallengeTeamsLeaderboardEntry';
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  team: Team;
};

export enum ChallengeType {
  Habit = 'Habit',
  Sleep = 'Sleep',
  Step = 'Step',
}

/** Input for submitting feedback on a chat interaction. */
export type ChatFeedbackInput = {
  /** An optional comment providing more detail about the feedback. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of reason keys (e.g. feedback.reason.inaccurate) indicating why the user gave this rating. */
  reason?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the user found the response helpful or not. */
  sentiment: ChatFeedbackSentiment;
  /**
   * The th1-trace-id returned in the SSE stream response body,
   * forwarded as TH1-Trace-Id to the Copilot API.
   */
  traceId: Scalars['ID']['input'];
};

/** Response returned after successfully submitting chat feedback. */
export type ChatFeedbackResponse = {
  __typename: 'ChatFeedbackResponse';
  /** A confirmation message from the API. */
  message: Scalars['String']['output'];
  /** Any warnings related to the submitted feedback (e.g. unrecognized reason keys). */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** The sentiment value for chat feedback. POSITIVE maps to thumbs up, NEGATIVE to thumbs down. */
export enum ChatFeedbackSentiment {
  /** The user found the response unhelpful. */
  Negative = 'NEGATIVE',
  /** The user found the response helpful. */
  Positive = 'POSITIVE',
}

/** An audio or video media item attached to an assistant message. */
export type ChatMedia = {
  __typename: 'ChatMedia';
  /** Duration in seconds. */
  duration?: Maybe<Scalars['Int']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  hlsUrl?: Maybe<Scalars['String']['output']>;
  placeholderId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Media type: audio or video. */
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A card-style media item attached to an assistant message. */
export type ChatMediaCard = {
  __typename: 'ChatMediaCard';
  author?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  placeholderId?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Media type: always card. */
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ChoiceQuestion = {
  __typename: 'ChoiceQuestion';
  contentItemId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  options: Array<ChoiceQuestionOption>;
  responseType: ChoiceQuestionResponseType;
  title: Scalars['String']['output'];
  userInteraction?: Maybe<ChoiceQuestionInteraction>;
};

export type ChoiceQuestionInteraction = {
  __typename: 'ChoiceQuestionInteraction';
  choices?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  seenByUser: Scalars['Boolean']['output'];
};

export type ChoiceQuestionInteractionInput = {
  choices?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contentItemId: Scalars['ID']['input'];
  seenByUser: Scalars['Boolean']['input'];
};

export type ChoiceQuestionOption = {
  __typename: 'ChoiceQuestionOption';
  label: Scalars['String']['output'];
  optionId: Scalars['ID']['output'];
};

export enum ChoiceQuestionResponseType {
  MultipleChoice = 'MultipleChoice',
  SingleChoice = 'SingleChoice',
}

/** A citation referenced in an assistant message. */
export type Citation = {
  __typename: 'Citation';
  author?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  /** Stringified chunk identifier — upstream may send a string or integer. */
  chunkId?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ClimbedEiffelTower = EndOfChallengeSummaryTotal & {
  __typename: 'ClimbedEiffelTower';
  total: Scalars['Int']['output'];
};

export type Color = {
  __typename: 'Color';
  hexCode: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompleteCarePlanActivityInput = {
  id: Scalars['ID']['input'];
};

export type CompleteCarePlanActivityResponse = {
  __typename: 'CompleteCarePlanActivityResponse';
  carePlanActivity?: Maybe<CarePlanActivity>;
};

export type CompletedCustomTierActivity = {
  __typename: 'CompletedCustomTierActivity';
  currentTier?: Maybe<CurrentTier>;
  customTierActivity: CustomTierActivity;
  nextTier?: Maybe<NextTier>;
  tierPoints?: Maybe<TierPoints>;
};

export type CompletedMarathonPercentage = EndOfChallengeSummaryTotal & {
  __typename: 'CompletedMarathonPercentage';
  total: Scalars['Int']['output'];
};

/** Details needed to initialize an AWS Connect Chat session. */
export type ConnectChatDetails = {
  __typename: 'ConnectChatDetails';
  awsRegion: Scalars['String']['output'];
  contactId: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
  participantToken: Scalars['String']['output'];
};

export type ConnectChatInitializationInput = {
  chatType: ConnectChatType;
};

export type ConnectChatInitializationResponse = {
  __typename: 'ConnectChatInitializationResponse';
  chatDetails?: Maybe<ConnectChatDetails>;
};

/** Chat type supported in the platform. */
export enum ConnectChatType {
  GlobalMultilingual = 'GLOBAL_MULTILINGUAL',
  Wpo = 'WPO',
}

export type ContentReportResponse = {
  __typename: 'ContentReportResponse';
  /** The same `ReportTargetKind` that was sent on the Mutation. */
  kind: ReportTargetKind;
};

/** A summary of a past conversation. */
export type ConversationItem = {
  __typename: 'ConversationItem';
  /** Date/Time when the conversation was created. */
  createdAt: Scalars['GraphQLDateTime']['output'];
  /** Identifier of the chat session — use as the TH1-Session-Id when resuming. */
  sessionId: Scalars['ID']['output'];
  /** Auto-derived title (typically the first user message). */
  title: Scalars['String']['output'];
  /** Date/Time of the last update. */
  updatedAt: Scalars['GraphQLDateTime']['output'];
};

/** A media item attached to an assistant message — either a ChatMedia or ChatMediaCard. */
export type ConversationMediaItem = ChatMedia | ChatMediaCard;

/** A single message in a conversation. */
export type ConversationMessage = {
  __typename: 'ConversationMessage';
  /** Citations referenced in this message. Present on assistant messages only. */
  citations?: Maybe<Array<Citation>>;
  /** Message text. May contain unresolved inline placeholders like [link1] / [c1]. */
  content: Scalars['String']['output'];
  /** User feedback sentiment: 1 (positive) or -1 (negative). Present on assistant messages only. */
  feedback?: Maybe<Scalars['Int']['output']>;
  /** Media items attached to this message. Present on assistant messages only. */
  media?: Maybe<Array<ConversationMediaItem>>;
  /** Navigation links suggested by this message. Present on assistant messages only. */
  navigationLinks?: Maybe<Array<NavigationLink>>;
  /** The author's role. */
  role: ConversationMessageRole;
  /** Trace ID linking this message to its upstream exchange. Present on assistant messages only. */
  traceId?: Maybe<Scalars['String']['output']>;
};

/** Role of a message author within a conversation. */
export enum ConversationMessageRole {
  /** Message generated by the AI assistant. */
  Assistant = 'ASSISTANT',
  /** System-level message used to set up the assistant's behaviour. Not typically surfaced in user-facing history. */
  System = 'SYSTEM',
  /** Output produced by a tool/function call. Not typically surfaced in user-facing history. */
  Tool = 'TOOL',
  /** Message authored by the end user. */
  User = 'USER',
}

/** Input for paginating messages within a conversation. */
export type ConversationMessagesInput = {
  /** Opaque cursor returned in the previous response's paging.cursors.after. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Max items per page (1–100). Defaults to upstream default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Sort direction. Defaults to DESC (newest first). */
  order?: InputMaybe<ConversationsOrderInput>;
};

/** Paginated list of messages in a conversation. */
export type ConversationMessagesResponse = {
  __typename: 'ConversationMessagesResponse';
  /** Messages for the current page. */
  data?: Maybe<Array<ConversationMessage>>;
  /** Pagination details. */
  paging: Pagination;
};

/** Input for paginating the list of conversations. */
export type ConversationsInput = {
  /** Opaque cursor returned in the previous response's paging.cursors.after. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Max items per page (1–100). Defaults to upstream default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Sort direction. Defaults to DESC (newest first). */
  order?: InputMaybe<ConversationsOrderInput>;
};

/** Order direction for paginated queries. */
export enum ConversationsOrderInput {
  /** Ascending order (oldest first). */
  Asc = 'ASC',
  /** Descending order (newest first). */
  Desc = 'DESC',
}

/** Paginated list of past conversations. */
export type ConversationsResponse = {
  __typename: 'ConversationsResponse';
  /** Conversation items for the current page. */
  data?: Maybe<Array<ConversationItem>>;
  /** Pagination details. */
  paging: Pagination;
};

export type Counsellor = {
  __typename: 'Counsellor';
  allowsBooking: Scalars['Boolean']['output'];
  appointmentTypes: Array<AppointmentType>;
  availableInNearFuture: Scalars['Boolean']['output'];
  avatarImage?: Maybe<Image>;
  displayHistory: Scalars['Boolean']['output'];
  /** @deprecated Use new flags defined here https://workivate.atlassian.net/wiki/spaces/MNT/pages/4642734121/Symphony+appointments+support */
  external: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<CounsellorInfo>;
  /** @deprecated Use `jobTitles`. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobTitles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  pronoun?: Maybe<Scalars['String']['output']>;
  spokenLanguages?: Maybe<Array<Maybe<Language>>>;
  timeSlots?: Maybe<Array<AvailableTimeSlot>>;
};

export type CounsellorTimeSlotsArgs = {
  input: FetchCounsellorTimeSlotInput;
};

export type CounsellorEducation = {
  __typename: 'CounsellorEducation';
  institution?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CounsellorFilter = {
  __typename: 'CounsellorFilter';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  options: Array<CounsellorFilterOption>;
  title: Scalars['String']['output'];
};

export type CounsellorFilterOption = {
  __typename: 'CounsellorFilterOption';
  /** @deprecated Deprecated, keep for backwards compatibility */
  counsellorIds: Array<Scalars['ID']['output']>;
  /** @deprecated Deprecated, keep for backwards compatibility */
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type CounsellorInfo = {
  __typename: 'CounsellorInfo';
  bio?: Maybe<Scalars['String']['output']>;
  disability?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer required in UI */
  educations?: Maybe<Array<Maybe<CounsellorEducation>>>;
  ethnicBackground?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  religion?: Maybe<Scalars['String']['output']>;
  sexualOrientation?: Maybe<Scalars['String']['output']>;
  specializations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CreateChallengeTeamInput = {
  challengeId: Scalars['ID']['input'];
  teamName: Scalars['String']['input'];
};

export type CreateChallengeTeamResponse = {
  __typename: 'CreateChallengeTeamResponse';
  team: Team;
};

export type CreateCustomMoodFactorInput = {
  /** User entered title for the custom mood factor. */
  title: Scalars['String']['input'];
};

export type CreateCustomMoodFactorResponse = {
  __typename: 'CreateCustomMoodFactorResponse';
  /** Newly created custom mood factor. */
  moodFactor: MoodFactor;
};

export type CreateGroupChallengeInput = {
  activityType: ChallengeActivityType;
  allowManualSteps: Scalars['Boolean']['input'];
  durationInDays: Scalars['Int']['input'];
  goal: Scalars['Int']['input'];
  /** The url returned by the member image upload. Without one the challenge shows the artwork of its template */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['GraphQLDateTime']['input'];
  targetType: TargetType;
  /** The creator's IANA timezone name, e.g. Europe/Warsaw. A bare offset such as +02:00 is rejected: the zone has to carry its own daylight saving rules for the window to be counted in calendar days */
  timezone: Scalars['GraphQLTimeZone']['input'];
  title: Scalars['String']['input'];
};

export type CreateGroupChallengeResponse = {
  __typename: 'CreateGroupChallengeResponse';
  challenge?: Maybe<GroupChallenge>;
};

export type CreateJournalEntryInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['GraphQLDateTime']['input'];
  title: Scalars['String']['input'];
};

export type CreateJournalEntryResponse = {
  __typename: 'CreateJournalEntryResponse';
  entry: JournalEntry;
};

export type CreateMoodEntryInput = {
  createdAt: Scalars['GraphQLDateTime']['input'];
  factors: Array<MoodFactorInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  value: MoodValue;
};

export type CreateMoodEntryResponse = {
  __typename: 'CreateMoodEntryResponse';
  entry: MoodEntry;
};

export type CurrentTier = {
  __typename: 'CurrentTier';
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  motivationalMessage: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type CurrentTierProgressSummary = {
  __typename: 'CurrentTierProgressSummary';
  currentTier?: Maybe<CurrentTier>;
  nextTier?: Maybe<NextTier>;
  points?: Maybe<TierPoints>;
};

export type CustomTierActivity = {
  __typename: 'CustomTierActivity';
  activityId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Image>;
  instructions?: Maybe<Scalars['String']['output']>;
  status: CustomTierActivityStatus;
  tierPointAward?: Maybe<TierPointAward>;
  title: Scalars['String']['output'];
};

export enum CustomTierActivityStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
}

export type DailyMoodDataPoint = {
  __typename: 'DailyMoodDataPoint';
  date: Scalars['GraphQLDate']['output'];
  /** Average mood for this day. In the range: 0 - 4 */
  value?: Maybe<Scalars['Float']['output']>;
};

export type DateTimeInterval = {
  end: Scalars['GraphQLDateTime']['input'];
  start: Scalars['GraphQLDateTime']['input'];
};

/** Result of deleting all conversations for the authenticated user. */
export type DeleteAllConversationsResult = {
  __typename: 'DeleteAllConversationsResult';
  /** Number of conversations deleted. */
  deletedCount: Scalars['Int']['output'];
  /** Session IDs of all deleted conversations. */
  deletedSessionIds: Array<Scalars['ID']['output']>;
};

/** Result of deleting all long-term memories for the authenticated user. */
export type DeleteAllMemoriesResult = {
  __typename: 'DeleteAllMemoriesResult';
  /** Number of memories deleted. */
  deletedCount: Scalars['Int']['output'];
};

/** Result of deleting a single conversation. */
export type DeleteConversationResult = {
  __typename: 'DeleteConversationResult';
  /** Session ID of the deleted conversation. */
  deletedSessionId: Scalars['ID']['output'];
};

export type DeleteCustomMoodFactorsInput = {
  /** Custom mood factors to delete. */
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteCustomMoodFactorsResponse = {
  __typename: 'DeleteCustomMoodFactorsResponse';
  received?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGroupChallengeResponse = {
  __typename: 'DeleteGroupChallengeResponse';
  challengeId: Scalars['ID']['output'];
  deleted: Scalars['Boolean']['output'];
};

export type DeleteJournalEntryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJournalEntryResponse = {
  __typename: 'DeleteJournalEntryResponse';
  received?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteMoodEntryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMoodEntryResponse = {
  __typename: 'DeleteMoodEntryResponse';
  received?: Maybe<Scalars['Boolean']['output']>;
};

export type DigitalClinicalContentItem =
  | Article
  | ChoiceQuestion
  | FreeTextQuestion
  | ScaleQuestion
  | StarRatingQuestion;

export type DigitalClinicalModule = {
  __typename: 'DigitalClinicalModule';
  backgroundImage?: Maybe<Image>;
  heroImage?: Maybe<Image>;
  introduction: Scalars['String']['output'];
  moduleId: Scalars['ID']['output'];
  progress: DigitalClinicalModuleProgress;
  sections?: Maybe<Array<DigitalClinicalModuleSection>>;
  status: DigitalClinicalModuleStatus;
  timeEstimate?: Maybe<TimeSpan>;
  title: Scalars['String']['output'];
};

export type DigitalClinicalModuleListItem = {
  __typename: 'DigitalClinicalModuleListItem';
  backgroundImage?: Maybe<Image>;
  heroImage?: Maybe<Image>;
  introduction: Scalars['String']['output'];
  moduleId: Scalars['ID']['output'];
  progress: DigitalClinicalModuleProgress;
  status: DigitalClinicalModuleStatus;
  timeEstimate?: Maybe<TimeSpan>;
  title: Scalars['String']['output'];
};

export type DigitalClinicalModuleProgress = {
  __typename: 'DigitalClinicalModuleProgress';
  completedContentItems: Scalars['Int']['output'];
  percentageComplete: Scalars['Float']['output'];
  remainingContentItems: Scalars['Int']['output'];
  totalContentItems: Scalars['Int']['output'];
};

export type DigitalClinicalModuleSection = {
  __typename: 'DigitalClinicalModuleSection';
  contentItems?: Maybe<Array<DigitalClinicalContentItem>>;
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum DigitalClinicalModuleStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
}

export type DigitalClinicalProgram = {
  __typename: 'DigitalClinicalProgram';
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  description: Scalars['String']['output'];
  icon?: Maybe<Image>;
  modules?: Maybe<Array<DigitalClinicalModuleListItem>>;
  programId: Scalars['ID']['output'];
  programType: DigitalClinicalProgramType;
  progress: DigitalClinicalProgramProgress;
  status: DigitalClinicalProgramStatus;
  title: Scalars['String']['output'];
  wasJoined: Scalars['Boolean']['output'];
};

export type DigitalClinicalProgramCategory = {
  __typename: 'DigitalClinicalProgramCategory';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Image>;
  iconBackground?: Maybe<Image>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DigitalClinicalProgramInteractionInput = {
  articleInteractions?: InputMaybe<Array<ArticleInteractionInput>>;
  choiceQuestionInteractions?: InputMaybe<
    Array<ChoiceQuestionInteractionInput>
  >;
  freeTextQuestionInteractions?: InputMaybe<
    Array<FreeTextQuestionInteractionInput>
  >;
  moduleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  scaleQuestionInteractions?: InputMaybe<Array<ScaleQuestionInteractionInput>>;
  starRatingQuestionInteractions?: InputMaybe<
    Array<StarRatingQuestionInteractionInput>
  >;
};

export type DigitalClinicalProgramListItem = {
  __typename: 'DigitalClinicalProgramListItem';
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  description: Scalars['String']['output'];
  icon?: Maybe<Image>;
  isLite?: Maybe<Scalars['Boolean']['output']>;
  nextModule?: Maybe<DigitalClinicalModuleListItem>;
  programId: Scalars['ID']['output'];
  programType: DigitalClinicalProgramType;
  progress: DigitalClinicalProgramProgress;
  status: DigitalClinicalProgramStatus;
  title: Scalars['String']['output'];
  wasJoined: Scalars['Boolean']['output'];
};

export type DigitalClinicalProgramProgress = {
  __typename: 'DigitalClinicalProgramProgress';
  completedModules: Scalars['Int']['output'];
  percentageComplete: Scalars['Float']['output'];
  remainingModules: Scalars['Int']['output'];
  totalModules: Scalars['Int']['output'];
};

export enum DigitalClinicalProgramStatus {
  Aborted = 'Aborted',
  Completed = 'Completed',
  Expired = 'Expired',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
}

export enum DigitalClinicalProgramType {
  Anxiety = 'Anxiety',
  Communication = 'Communication',
  Coping = 'Coping',
  Depression = 'Depression',
  Grief = 'Grief',
  Health = 'Health',
  Money = 'Money',
  Pain = 'Pain',
  Relationships = 'Relationships',
  Separation = 'Separation',
  Sleep = 'Sleep',
  Stress = 'Stress',
  SubstanceAbuse = 'SubstanceAbuse',
  Trauma = 'Trauma',
  Work = 'Work',
}

export type EditJournalEntryInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['GraphQLDateTime']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type EditJournalEntryResponse = {
  __typename: 'EditJournalEntryResponse';
  entry: JournalEntry;
};

export type EditMoodEntryInput = {
  createdAt: Scalars['GraphQLDateTime']['input'];
  factors: Array<MoodFactorInput>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  value: MoodValue;
};

export type EditMoodEntryResponse = {
  __typename: 'EditMoodEntryResponse';
  entry: MoodEntry;
};

export type EditSelectedHabitsCaption = {
  __typename: 'EditSelectedHabitsCaption';
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EndOfChallengeSummaryTotal = {
  total: Scalars['Int']['output'];
};

export enum ExerciseActivityType {
  Running = 'RUNNING',
  Travel = 'TRAVEL',
  Unknown = 'UNKNOWN',
  Walking = 'WALKING',
}

export type ExerciseEvent = {
  __typename: 'ExerciseEvent';
  activityType: ExerciseActivityType;
  endedAt: Scalars['GraphQLDateTime']['output'];
  quantity: Scalars['Int']['output'];
  startedAt: Scalars['GraphQLDateTime']['output'];
};

export type ExerciseEventInput = {
  activityDeviceType?: InputMaybe<ActivityDeviceType>;
  /** Enumerated activity type */
  activityType: ExerciseActivityType;
  /** Raw activity type value as sent by the activity data source */
  activityTypeRaw?: InputMaybe<Scalars['String']['input']>;
  appSource?: InputMaybe<Scalars['String']['input']>;
  /** Date/Time provided in UTC e.g 2021-02-23T10:15:30Z */
  endedAt: Scalars['GraphQLDateTime']['input'];
  quantity: Scalars['Int']['input'];
  /** Date/Time provided in UTC e.g 2021-02-23T10:15:30Z */
  startedAt: Scalars['GraphQLDateTime']['input'];
};

export type FailedToAddTeamMember = {
  __typename: 'FailedToAddTeamMember';
  id: Scalars['ID']['output'];
};

export type FavoriteMerchantInput = {
  id: Scalars['ID']['input'];
};

export type FavoriteMerchantResponse = {
  __typename: 'FavoriteMerchantResponse';
  merchant: Merchant;
};

export type FeaturedAssessment = {
  __typename: 'FeaturedAssessment';
  assessment: AssessmentListItem;
  assessmentsRemaining?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  icon?: Maybe<Image>;
  introduction: Scalars['String']['output'];
  numberOfAssessments?: Maybe<Scalars['Int']['output']>;
  status: AssessmentStatus;
  tierPoints?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type Feedback = {
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum FeedbackId {
  CopilotChat = 'COPILOT_CHAT',
  Onboarding = 'ONBOARDING',
}

/** A single feedback reason with a stable ID and localized display label */
export type FeedbackReason = {
  __typename: 'FeedbackReason';
  /** Stable translation key used as the reason identifier on submission (e.g. feedback.reason.inaccurate) */
  id: Scalars['String']['output'];
  /** Localized display label shown to the user */
  label: Scalars['String']['output'];
};

/** Input for fetching localized feedback reasons */
export type FeedbackReasonsInput = {
  /**
   * Locale for localization (e.g. en-ca, en_CA, fr-ca;q=0.9).
   * Normalized internally to lowercase hyphenated format.
   */
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing available feedback reasons and the locale that was applied */
export type FeedbackReasonsResponse = {
  __typename: 'FeedbackReasonsResponse';
  /** The effective locale used for localization (may differ from requested locale if a fallback was applied) */
  locale: Scalars['String']['output'];
  /** List of selectable feedback reasons */
  reasons: Array<FeedbackReason>;
};

export type FeedbackRequest = {
  __typename: 'FeedbackRequest';
  /**
   * The text that prompts for free input after the user has selected a negative rating.
   * Localized string.
   */
  negativeFreeTextInputPrompt: Scalars['String']['output'];
  /**
   * The text that prompts for free input after the user has selected a positive rating.
   * Localized string.
   */
  positiveFreeTextInputPrompt: Scalars['String']['output'];
  /**
   * The main question for the feedback request.
   * Localized string.
   */
  question: Scalars['String']['output'];
  /** Max length for the free-text input. */
  textInputMaxLength: Scalars['Int']['output'];
};

export type FeedbackRequestInput = {
  id: FeedbackId;
};

export type FeedbackRequestResponse = {
  __typename: 'FeedbackRequestResponse';
  /** If the user shouldn't see this feedback request at this time, this field should be null so FE won't prompt for it. */
  feedbackRequest?: Maybe<FeedbackRequest>;
};

export type FetchAppointmentByIdInput = {
  appointmentId: Scalars['ID']['input'];
};

export type FetchAppointmentResponse = {
  __typename: 'FetchAppointmentResponse';
  appointment: Appointment;
};

export type FetchAppointmentsInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FetchAppointmentsOrder>;
  where?: InputMaybe<FetchAppointmentsWhere>;
};

export type FetchAppointmentsOrder = {
  startDateTime?: InputMaybe<Order>;
};

export type FetchAppointmentsResponse = {
  __typename: 'FetchAppointmentsResponse';
  appointments: PaginatedAppointments;
};

export type FetchAppointmentsWhere = {
  endDateTime?: InputMaybe<AppointmentsDateTimeFilter>;
  startDateTime?: InputMaybe<AppointmentsDateTimeFilter>;
  statuses?: InputMaybe<Array<AppointmentStatus>>;
};

export type FetchAssessmentsResponse = {
  __typename: 'FetchAssessmentsResponse';
  assessments?: Maybe<Array<AssessmentListItem>>;
  contentLanguage?: Maybe<Scalars['String']['output']>;
  translatedGlobalContentExists: Scalars['Boolean']['output'];
};

export type FetchCounsellorByIdInput = {
  counsellorId: Scalars['ID']['input'];
};

export type FetchCounsellorFiltersInput = {
  where?: InputMaybe<FetchCounsellorFiltersInputWhere>;
};

export type FetchCounsellorFiltersInputWhere = {
  /** @deprecated Deprecated */
  appointmentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Deprecated */
  disability?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Deprecated */
  ethnicBackground?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Deprecated */
  gender?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId: Scalars['ID']['input'];
  /** @deprecated Deprecated */
  religion?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Deprecated */
  sexualOrientation?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Deprecated */
  specializations?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated Deprecated */
  spokenLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FetchCounsellorFiltersResponse = {
  __typename: 'FetchCounsellorFiltersResponse';
  filters: Array<CounsellorFilter>;
};

export type FetchCounsellorResponse = {
  __typename: 'FetchCounsellorResponse';
  counsellor: Counsellor;
};

export type FetchCounsellorTimeSlotInput = {
  where?: InputMaybe<FetchCounsellorTimeSlotWhere>;
};

export type FetchCounsellorTimeSlotWhere = {
  interval?: InputMaybe<DateTimeInterval>;
};

export type FetchCounsellorsFiltersInputWhere = {
  filterId: Scalars['String']['input'];
  selectedOptionIds: Array<Scalars['ID']['input']>;
};

export type FetchCounsellorsInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FetchCounsellorsWhere>;
};

export type FetchCounsellorsResponse = {
  __typename: 'FetchCounsellorsResponse';
  counsellors: PaginatedCounsellors;
};

export type FetchCounsellorsWhere = {
  filters?: InputMaybe<Array<FetchCounsellorsFiltersInputWhere>>;
  /** @deprecated Deprecated, keep for backwards compatibility */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type FetchFirstOfferedAppointmentInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type FetchFirstOfferedAvailableTimeSlotResponse = {
  __typename: 'FetchFirstOfferedAvailableTimeSlotResponse';
  availableTimeSlot: AvailableTimeSlot;
};

export type FetchMerchantsOrder = {
  order?: InputMaybe<MerchantsSort>;
};

export type FetchMerchantsResponse = {
  __typename: 'FetchMerchantsResponse';
  merchants: MerchantsPaginatedResponse;
};

export type FetchMerchantsWhere = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  onlyFavorites?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PerksType>;
};

export type FetchOffersOrder = {
  order?: InputMaybe<OffersSort>;
};

export type FetchOffersResponse = {
  __typename: 'FetchOffersResponse';
  offers: OffersPaginatedResponse;
};

export type FetchOffersWhere = {
  /** Use this to filter only for Cashback standard rates or special offers. */
  cashbackOfferRateType?: InputMaybe<CashbackOfferRateType>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PerksType>;
};

export type FetchTeamResponse = {
  __typename: 'FetchTeamResponse';
  /**
   * Returns a paginated team members leaderboard showing
   * who is winning the corporate challenge within a team.
   * If the corporate challenge has not started the users
   * will be returned in alphabetical order without a score.
   * Once the corporate challenge is in progress the list will
   * be a leaderboard showing which user is currently winning.
   * The leaderboard is ordered by each team member's score.
   */
  leaderboardTeamMembers: LeaderboardTeamMembersResponse;
  team?: Maybe<Team>;
};

export type FetchTeamResponseLeaderboardTeamMembersArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  challengeId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type FetchTransactionResult = {
  __typename: 'FetchTransactionResult';
  data?: Maybe<Transaction>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FetchUserSubdivisionsResponse = {
  __typename: 'FetchUserSubdivisionsResponse';
  subdivisions: Array<Subdivision>;
};

export type FilterAssessmentsInput = {
  category?: InputMaybe<Array<InputMaybe<AssessmentCategory>>>;
  status: Array<InputMaybe<AssessmentStatus>>;
};

export type FilterChallengesInput = {
  participationType?: InputMaybe<ChallengeParticipationType>;
  status?: InputMaybe<Array<InputMaybe<ChallengeStatus>>>;
  /** Indicates if the current user is actively in the challenge */
  wasJoined?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterDigitalClinicalProgramsInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<InputMaybe<DigitalClinicalProgramStatus>>>;
  wasJoined?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterPreAssessmentHistoryInput = {
  /** Specify the id of the assessment history to retrieve. */
  careAssessmentId?: InputMaybe<Scalars['ID']['input']>;
  pagination?: InputMaybe<PreAssessmentHistoryPaginationInput>;
};

export type FilterPreAssessmentInput = {
  /** Optionally specify the id of the next assessment to retrieve. */
  careAssessmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Start the retake flow. If missing, assume we are not performing a retake. */
  retake?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The current retake session in progress. Passed to subsequent requests once a user starts a retake
   * session by using 'retake: true'. Assessments will be served in order within the same session.
   */
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export type FindAssessmentHistoryInput = {
  uuid: Scalars['ID']['input'];
};

export type FindAssessmentInput = {
  uuid: Scalars['ID']['input'];
};

export type FindChallengeTeamsLeaderboardInput = {
  challengeId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
};

export type FindCustomTierActivityInput = {
  activityId: Scalars['ID']['input'];
};

export type FindDigitalClinicalCategoryInput = {
  categoryId: Scalars['ID']['input'];
};

export type FindDigitalClinicalModuleInput = {
  moduleId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};

export type FindDigitalClinicalProgramInput = {
  programId: Scalars['ID']['input'];
};

export type FindHistoricalAssessmentInput = {
  archiveId: Scalars['ID']['input'];
};

export type FindTooltipInput = {
  tooltipId: TooltipId;
};

export type Font = {
  __typename: 'Font';
  color?: Maybe<Color>;
};

export type FormattedText = {
  __typename: 'FormattedText';
  body: Scalars['String']['output'];
  format: TextFormat;
};

export type FreeTextQuestion = {
  __typename: 'FreeTextQuestion';
  contentItemId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userInteraction?: Maybe<FreeTextQuestionInteraction>;
};

export type FreeTextQuestionInteraction = {
  __typename: 'FreeTextQuestionInteraction';
  seenByUser: Scalars['Boolean']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type FreeTextQuestionInteractionInput = {
  contentItemId: Scalars['ID']['input'];
  seenByUser: Scalars['Boolean']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type GetActivitySourceResponse = {
  __typename: 'GetActivitySourceResponse';
  source: ActivitySourceDevice;
};

export type GetCareIssuesInput = {
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetChallengeTeamsLeaderboardResponse = {
  __typename: 'GetChallengeTeamsLeaderboardResponse';
  challengeTeamsLeaderboard: Array<Maybe<ChallengeTeamsLeaderboardEntry>>;
  paging?: Maybe<Pagination>;
};

export type GetGroupChallengeResponse = {
  __typename: 'GetGroupChallengeResponse';
  challenge?: Maybe<GroupChallenge>;
};

export type GetHowItWorksInput = {
  wpoServiceType: WpoServiceType;
};

export type GetHowItWorksResponse = {
  __typename: 'GetHowItWorksResponse';
  headerImageUrl: Scalars['String']['output'];
};

export type GlobalIntakeAppointmentRequestInput = {
  /** Email the user wants to be contacted at. */
  email: Scalars['String']['input'];
  /**
   * Standard locale format for the language used in the rest of the platform.
   * Supports both "en-gb" and "en_gb", just like the language header.
   */
  language: Scalars['String']['input'];
  /** Phone number the user wants to be contacted at. This is nullable for retro compatibility with natives apps. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Preferred date the user has selected for the appointment to take place. */
  preferredDate: Scalars['GraphQLDate']['input'];
  /** Preferred meridiem (before/after midday) for the appointment to take place. */
  preferredMeridiem: PreferredMeridiem;
  /** Preferred method to be contacted with Email or Phone. This is nullable for retro compatibility with natives apps. */
  preferredMethodOfContact?: InputMaybe<MethodOfContact>;
  /**
   * Standard TZ identifier.
   * Example: America/Los_Angeles, Europe/London
   */
  timezone: Scalars['String']['input'];
  /** User preference if Telus can leave voicemail for them. This is nullable for retro compatibility with natives apps. */
  voicemailPreference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GlobalIntakeAppointmentRequestResponse = {
  __typename: 'GlobalIntakeAppointmentRequestResponse';
  /** Email the user wants to be contacted at. */
  email: Scalars['String']['output'];
  /**
   * Standard locale format for the language used in the rest of the platform.
   * Supports both "en-gb" and "en_gb", just like the language header.
   */
  language: Scalars['String']['output'];
  /** Phone number the user wants to be contacted at. This is nullable for retro compatibility with natives apps. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Preferred date the user has selected for the appointment to take place. */
  preferredDate: Scalars['GraphQLDate']['output'];
  /** Preferred meridiem (before/after midday) for the appointment to take place. */
  preferredMeridiem: PreferredMeridiem;
  /** Preferred method to be contacted with Email or Phone. This is nullable for retro compatibility with natives apps. */
  preferredMethodOfContact?: Maybe<MethodOfContact>;
  /**
   * Standard TZ identifier.
   * Example: America/Los_Angeles, Europe/London
   */
  timezone: Scalars['String']['output'];
  /** User preference if Telus can leave voicemail for them or not. This is nullable for retro compatibility with natives apps. */
  voicemailPreference?: Maybe<Scalars['Boolean']['output']>;
};

/** Response type for member assistant greeting */
export type GreetingResponse = {
  __typename: 'GreetingResponse';
  /** Capability statement describing what the assistant can do */
  capabilityStatement: Scalars['String']['output'];
  /** The greeting message */
  greeting: Scalars['String']['output'];
  /** Introduction message */
  introduction: Scalars['String']['output'];
  /** The locale used for the greeting */
  locale: Scalars['String']['output'];
};

export type GroupChallenge = GroupStepChallenge;

export type GroupChallengeConfig = {
  __typename: 'GroupChallengeConfig';
  /** Every activity type. Group by `status` to render the sections — array position carries no meaning */
  activityTypes: Array<ChallengeActivityTypeOption>;
  limits: GroupChallengeLimits;
};

export type GroupChallengeLimits = {
  __typename: 'GroupChallengeLimits';
  /** Maximum length of a group challenge title, in characters */
  titleMaxLength: Scalars['Int']['output'];
};

export type GroupChallengeParticipant = {
  __typename: 'GroupChallengeParticipant';
  companyId: Scalars['ID']['output'];
  joinedAt: Scalars['GraphQLDateTime']['output'];
  status: GroupChallengeParticipantStatus;
  userId: Scalars['ID']['output'];
};

export enum GroupChallengeParticipantStatus {
  Active = 'Active',
  Failed = 'Failed',
  Succeeded = 'Succeeded',
}

export enum GroupChallengeStatus {
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
}

export type GroupStepChallenge = {
  __typename: 'GroupStepChallenge';
  allowManualSteps: Scalars['Boolean']['output'];
  /** Extended from challenge-api */
  challengeId: Scalars['ID']['output'];
  creatorUserId: Scalars['ID']['output'];
  durationInDays: Scalars['Int']['output'];
  endDate: Scalars['GraphQLDateTime']['output'];
  goal: Scalars['Int']['output'];
  /** The uploaded image, or the artwork of the template when there is none. The url carries the same placeholders as every other challenge image */
  image: Image;
  lastUploaded?: Maybe<Scalars['GraphQLDateTime']['output']>;
  participants: Array<GroupChallengeParticipant>;
  participationType: ChallengeParticipationType;
  participationTypeDisplayText: Scalars['String']['output'];
  startDate: Scalars['GraphQLDateTime']['output'];
  status: GroupChallengeStatus;
  stepActivity: StepActivityResponse;
  targetType: TargetType;
  templateId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type GroupStepChallengeStepActivityArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type Habit = {
  __typename: 'Habit';
  description?: Maybe<Scalars['String']['output']>;
  habitId: Scalars['ID']['output'];
  options?: Maybe<Array<HabitOption>>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  subtitle: Scalars['String']['output'];
  thumbnailImage?: Maybe<Image>;
  title: Scalars['String']['output'];
  tracked?: Maybe<Scalars['Int']['output']>;
  tradeCaptions: HabitTradeCaption;
};

export type HabitActivity = {
  __typename: 'HabitActivity';
  habit?: Maybe<Habit>;
  optionActivity: Array<Maybe<HabitOptionActivity>>;
};

export type HabitActivityResponse = {
  __typename: 'HabitActivityResponse';
  activity?: Maybe<Array<HabitDailyActivity>>;
  pagination?: Maybe<Pagination>;
};

export type HabitChallenge = {
  __typename: 'HabitChallenge';
  activity: HabitActivityResponse;
  activityTracking?: Maybe<ChallengeActivityTracking>;
  category: ChallengeCategory;
  categoryDisplayText: Scalars['String']['output'];
  challengeHabits?: Maybe<ChallengeHabits>;
  /** Extended from challenge-api */
  challengeId: Scalars['ID']['output'];
  challengeType?: Maybe<ChallengeType>;
  completionReward?: Maybe<TierReward>;
  defaultPromotionalPost?: Maybe<Scalars['String']['output']>;
  durationInDays?: Maybe<Scalars['Int']['output']>;
  endDateTimeISO?: Maybe<Scalars['GraphQLDateTime']['output']>;
  goal: Scalars['Int']['output'];
  image?: Maybe<Image>;
  introduction?: Maybe<Array<Maybe<ChallengeIntroduction>>>;
  /**
   * Returns a paginated individuals leaderboard for a specific
   * date. The leaderboard includes everyone in the company
   * who is participating in the challenge.
   * If the corporate challenge has not started the users
   * will be returned in alphabetical order without a score.
   * Once the corporate challenge is in progress the list will
   * be a leaderboard showing which user is currently winning.
   * The leaderboard is ordered by every user's score.
   */
  leaderboardIndividuals: LeaderboardIndividualResponse;
  /**
   * Returns a paginated teams leaderboard for a specific date
   * If the corporate challenge has not started the teams will
   * be returned in alphabetical order without a score.
   * Once the corporate challenge is in progress the list will
   * be a leaderboard showing which team is currently winning.
   * The leaderboard is ordered by the team's score.
   * The team's score is an average of active team members' scores.
   * If the user's team is on the first page then we prepend
   * the team to the top of the list
   */
  leaderboardTeams: LeaderboardTeamResponse;
  participant?: Maybe<ChallengeParticipant>;
  participants?: Maybe<Scalars['Int']['output']>;
  participationType: ChallengeParticipationType;
  participationTypeDisplayText: Scalars['String']['output'];
  result?: Maybe<ChallengeResult>;
  startDateTimeISO?: Maybe<Scalars['GraphQLDateTime']['output']>;
  status: ChallengeStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Scalars['Int']['output']>;
  templateId: Scalars['ID']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userTeamMembership: UserTeamMembershipResponse;
  /** Indicates if the current user is actively in the challenge */
  wasJoined: Scalars['Boolean']['output'];
};

export type HabitChallengeActivityArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type HabitChallengeLeaderboardIndividualsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type HabitChallengeLeaderboardTeamsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type HabitDailyActivity = {
  __typename: 'HabitDailyActivity';
  activity?: Maybe<Array<HabitActivity>>;
  date: Scalars['GraphQLDate']['output'];
  id: Scalars['ID']['output'];
  subtitle: Scalars['String']['output'];
  tracked: Scalars['Int']['output'];
  tradeLimit: Scalars['Int']['output'];
};

export type HabitOption = {
  __typename: 'HabitOption';
  optionId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type HabitOptionActivity = {
  __typename: 'HabitOptionActivity';
  option?: Maybe<HabitOption>;
  tracked: Scalars['Int']['output'];
};

export type HabitTradeCaption = {
  __typename: 'HabitTradeCaption';
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type HealthRiskAssessmentCard = {
  __typename: 'HealthRiskAssessmentCard';
  assessmentsRemaining: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  heroCardId: Scalars['String']['output'];
  icon?: Maybe<Image>;
  introduction: Scalars['String']['output'];
  nextAssessment: AssessmentListItem;
  numberOfAssessments: Scalars['Int']['output'];
  status: AssessmentStatus;
  tierPoints?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type HistoricalAssessment = {
  __typename: 'HistoricalAssessment';
  archiveId: Scalars['ID']['output'];
  assessmentUuid: Scalars['ID']['output'];
  result?: Maybe<AssessmentListItemResult>;
};

export type HitGoal = EndOfChallengeSummaryTotal & {
  __typename: 'HitGoal';
  total: Scalars['Int']['output'];
};

export type HowDoesPersonalisationWorkResponse = {
  __typename: 'HowDoesPersonalisationWorkResponse';
  body: Scalars['String']['output'];
  button: Scalars['String']['output'];
  icon?: Maybe<Image>;
  /** only returned if the user has the enhanced_personalisation fk */
  permission?: Maybe<HowPersonalisationWorksPermission>;
  title: Scalars['String']['output'];
};

export type HowPersonalisationWorksPermission = {
  __typename: 'HowPersonalisationWorksPermission';
  allowPersonalisation?: Maybe<Scalars['Boolean']['output']>;
  body: Scalars['String']['output'];
  footer?: Maybe<Scalars['String']['output']>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type HowToEarnTierPoints = {
  __typename: 'HowToEarnTierPoints';
  image: Image;
  route: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type HraPromotion = {
  __typename: 'HraPromotion';
  assessment?: Maybe<FeaturedAssessment>;
  externalId: Scalars['ID']['output'];
  icon?: Maybe<Image>;
  image?: Maybe<Image>;
  message?: Maybe<Scalars['String']['output']>;
  promotionType?: Maybe<PromotionType>;
  schedule?: Maybe<WellbeingPromotionSchedule>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tierPoints?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type Image = {
  __typename: 'Image';
  font?: Maybe<Font>;
  url: Scalars['String']['output'];
};

export type IndividualsLeaderboardEntry = {
  __typename: 'IndividualsLeaderboardEntry';
  hasTrackedManual?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  /** Extended from team-api */
  user: User;
};

export type InfluencesMoodDataPoint = {
  __typename: 'InfluencesMoodDataPoint';
  factor: Scalars['String']['output'];
  valueMax: Scalars['Int']['output'];
  valueMin: Scalars['Int']['output'];
};

export type InfluencesMoodInsightsInput = {
  from?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type InfluencesMoodInsightsResponse = {
  __typename: 'InfluencesMoodInsightsResponse';
  data: Array<InfluencesMoodDataPoint>;
  message: Scalars['String']['output'];
  /** Number of entries taken into account to compute the data points. */
  sampleSize: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type Interest = {
  __typename: 'Interest';
  id: Scalars['ID']['output'];
  /** Localized name for the interest. */
  name: Scalars['String']['output'];
  /** True if the user has selected this interest. */
  selected: Scalars['Boolean']['output'];
};

export type InterestGroup = {
  __typename: 'InterestGroup';
  /** True if the user is focusing on an interest of this group. */
  focused: Scalars['Boolean']['output'];
  /** Icon representing the image group. */
  icon: Image;
  id: Scalars['ID']['output'];
  /** Array of interests corresponding to the group. */
  interests: Array<Interest>;
  /** Localized name for the interest group. */
  name: Scalars['String']['output'];
};

export type InterestsResponse = {
  __typename: 'InterestsResponse';
  /** List of interest groups. */
  groups: Array<InterestGroup>;
};

export type JoinChallengeResponse = {
  __typename: 'JoinChallengeResponse';
  challenge?: Maybe<Challenge>;
};

export type JoinChallengeTeamInput = {
  challengeId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type JoinChallengeTeamResponse = {
  __typename: 'JoinChallengeTeamResponse';
  joinedTeam: Scalars['Boolean']['output'];
  /** Users cannot join a team if they are in an existing team */
  reasonNotJoined?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
};

export type JoinDigitalClinicalProgramInput = {
  programId: Scalars['ID']['input'];
};

export type JoinGroupChallengeResponse = {
  __typename: 'JoinGroupChallengeResponse';
  challenge?: Maybe<GroupChallenge>;
};

export type JournalEntriesInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type JournalEntriesResponse = {
  __typename: 'JournalEntriesResponse';
  entries: PaginatedJournalEntries;
};

/** Journal entry for the Journaling feature. */
export type JournalEntry = {
  __typename: 'JournalEntry';
  /** Journal body added by the user. */
  body?: Maybe<Scalars['String']['output']>;
  /** Date time when the user created the journal entry. */
  date: Scalars['GraphQLDateTime']['output'];
  id: Scalars['ID']['output'];
  /** Title for the entry added by the user. */
  title: Scalars['String']['output'];
};

export type Language = {
  __typename: 'Language';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LeaderboardIndividualResponse = {
  __typename: 'LeaderboardIndividualResponse';
  leaderboard?: Maybe<Array<IndividualsLeaderboardEntry>>;
  pagination?: Maybe<Pagination>;
};

export type LeaderboardTeamMembersResponse = {
  __typename: 'LeaderboardTeamMembersResponse';
  leaderboard?: Maybe<Array<IndividualsLeaderboardEntry>>;
  pagination?: Maybe<Pagination>;
};

export type LeaderboardTeamResponse = {
  __typename: 'LeaderboardTeamResponse';
  leaderboard?: Maybe<Array<TeamsLeaderboardEntry>>;
  pagination?: Maybe<Pagination>;
};

export type LeaveChallengeResponse = {
  __typename: 'LeaveChallengeResponse';
  challenge?: Maybe<Challenge>;
};

export type LeaveChallengeTeamInput = {
  challengeId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type LeaveChallengeTeamResponse = {
  __typename: 'LeaveChallengeTeamResponse';
  departedTeam: Scalars['Boolean']['output'];
  /** Users cannot leave a team if the challenge has started */
  reasonNotDeparted?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  /** If they are the last team member, the team is deleted */
  teamDeleted: Scalars['Boolean']['output'];
};

export type LeaveDigitalClinicalProgramInput = {
  programId: Scalars['ID']['input'];
};

export type LeaveGroupChallengeResponse = {
  __typename: 'LeaveGroupChallengeResponse';
  challenge?: Maybe<GroupChallenge>;
};

export type ListGroupChallengesInput = {
  /** The after cursor of the previous page, absent for the first one */
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  /** How many challenges to return, up to a maximum of 100. Defaults to 10 */
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type ListGroupChallengesResponse = {
  __typename: 'ListGroupChallengesResponse';
  challenges: Array<GroupChallenge>;
  pagination: Pagination;
};

export type MandatoryTierActivities = {
  __typename: 'MandatoryTierActivities';
  completed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  route: Scalars['String']['output'];
};

export type MeasurementRanges = {
  __typename: 'MeasurementRanges';
  jumpTo?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  range?: Maybe<Scalars['String']['output']>;
};

export type MeasurementResultFeedback = Feedback & {
  __typename: 'MeasurementResultFeedback';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MembersPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type MembersResponse = {
  __typename: 'MembersResponse';
  members?: Maybe<Array<User>>;
  pagination?: Maybe<Pagination>;
};

export type Merchant = {
  __typename: 'Merchant';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  infoPayment?: Maybe<PerksFormattedTextSection>;
  infoReturn?: Maybe<PerksFormattedTextSection>;
  infoShipping?: Maybe<PerksFormattedTextSection>;
  infoSpecialTerms?: Maybe<PerksFormattedTextSection>;
  infoTax?: Maybe<PerksFormattedTextSection>;
  isFavorite: Scalars['Boolean']['output'];
  logo?: Maybe<Image>;
  name: Scalars['String']['output'];
  /**
   * Offers of this Merchant.
   * Use this with a limit of 1 and sort of `highestCashback` to retrieve the highest cashback value of this Merchant.
   */
  offers?: Maybe<FetchOffersResponse>;
  termsAndConditions: Array<PerksFormattedTextSection>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MerchantOffersArgs = {
  input: OffersInput;
};

export type MerchantInput = {
  id: Scalars['ID']['input'];
};

export type MerchantResponse = {
  __typename: 'MerchantResponse';
  merchant: Merchant;
};

export type MerchantsInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FetchOffersOrder>;
  where?: InputMaybe<FetchOffersWhere>;
};

export type MerchantsPaginatedResponse = {
  __typename: 'MerchantsPaginatedResponse';
  data: Array<Merchant>;
  paging?: Maybe<Pagination>;
};

export enum MerchantsSort {
  Alphabetical = 'alphabetical',
  EndingSoon = 'endingSoon',
  HighestCashback = 'highestCashback',
  MostPopular = 'mostPopular',
  MostSpecialOffers = 'mostSpecialOffers',
  SelectedByWa = 'selectedByWA',
}

export enum MethodOfContact {
  Email = 'EMAIL',
  Phone = 'PHONE',
}

export type MockMutationInput = {
  id: Scalars['ID']['input'];
};

export type MockMutationResponse = {
  __typename: 'MockMutationResponse';
  received: Scalars['Boolean']['output'];
};

export type MoodEntriesDateTimeFilter = {
  from?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  to?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
};

export type MoodEntriesInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Order is assumed to be from most recent to oldest. */
  where?: InputMaybe<MoodEntriesWhere>;
};

export type MoodEntriesResponse = {
  __typename: 'MoodEntriesResponse';
  entries: PaginatedMoodEntries;
};

export type MoodEntriesWhere = {
  createdAt?: InputMaybe<MoodEntriesDateTimeFilter>;
};

/** Mood entry for the Mood Tracking feature. */
export type MoodEntry = {
  __typename: 'MoodEntry';
  /** Date time when the user created the entry. */
  createdAt: Scalars['GraphQLDateTime']['output'];
  /** Factors that contributed to the user's mood. */
  factors: Array<MoodFactor>;
  id: Scalars['ID']['output'];
  /** Free text entry note added by the user. */
  note?: Maybe<Scalars['String']['output']>;
  /** Value for the mood feling. */
  value: MoodValue;
};

/** Factor that contributes to the user's mood feeling. */
export type MoodFactor = {
  __typename: 'MoodFactor';
  id: Scalars['ID']['output'];
  /** Custom Mood Factor created by the user. */
  isCustom: Scalars['Boolean']['output'];
  /** Localized string. */
  title: Scalars['String']['output'];
};

export type MoodFactorInput = {
  id: Scalars['ID']['input'];
};

/**
 * Value for the mood feling.
 * FE matches this value to the UI for each feeling.
 */
export enum MoodValue {
  Amazing = 'AMAZING',
  Awful = 'AWFUL',
  Bad = 'BAD',
  Good = 'GOOD',
  Ok = 'OK',
}

export type Mutation = {
  __typename: 'Mutation';
  answerAssessmentQuestions?: Maybe<AnswerAssessmentQuestionsResponse>;
  answerPreAssessment?: Maybe<AnswerPreAssessmentResponse>;
  /**
   * Allows a user to call for immediate help at the start of their care journey.
   * We will also inform the care provider that the user has identified themselves as at risk.
   */
  askForImmediateHelp?: Maybe<AskForImmediateHelpResponse>;
  /**
   * Due to the async nature of Careplan assignment to a user, this mutation will not return the Care Plan and instead return a received flag.
   * This mutation is idempotent.
   */
  assignCarePlan?: Maybe<AssignCarePlanResponse>;
  bookAppointment?: Maybe<BookAppointmentResponse>;
  cancelAppointment?: Maybe<CancelAppointmentResponse>;
  changeGender?: Maybe<ChangeGenderResponse>;
  completeCarePlanActivity?: Maybe<CompleteCarePlanActivityResponse>;
  completeCustomTierActivity?: Maybe<CompletedCustomTierActivity>;
  completeWalkthrough?: Maybe<Scalars['Boolean']['output']>;
  createChallengeTeam?: Maybe<CreateChallengeTeamResponse>;
  /** Create a new user created custom mood factor. */
  createCustomMoodFactor?: Maybe<CreateCustomMoodFactorResponse>;
  createGroupChallenge: CreateGroupChallengeResponse;
  /**
   * Creates a new journal entry for the current user with the given input.
   * It returns the newly created journal entry.
   */
  createJournalEntry?: Maybe<CreateJournalEntryResponse>;
  /**
   * Creates a new mood entry for the current user with the given input.
   * It returns the newly created mood entry.
   */
  createMoodEntry?: Maybe<CreateMoodEntryResponse>;
  /**
   * Hard-delete all conversations owned by the authenticated user, including
   * their associated long-term memory entries. Proxies to
   * DELETE /api/v1/conversations.
   */
  deleteAllConversations: DeleteAllConversationsResult;
  /**
   * Hard-delete all long-term memories owned by the authenticated user. Proxies to
   * DELETE /api/v1/memories.
   */
  deleteAllMemories: DeleteAllMemoriesResult;
  /**
   * Hard-delete a conversation owned by the authenticated user, including
   * its associated long-term memory entries. Proxies to
   * DELETE /api/v1/conversations/{session_id}.
   */
  deleteConversation: DeleteConversationResult;
  /** Delete user created custom mood factors. */
  deleteCustomMoodFactors?: Maybe<DeleteCustomMoodFactorsResponse>;
  deleteGroupChallenge: DeleteGroupChallengeResponse;
  /**
   * Deletes the journal entry of the current user with the given id.
   * Note: This is assumed to be a synchronous operation
   */
  deleteJournalEntry?: Maybe<DeleteJournalEntryResponse>;
  /** Deletes the mood entry of the current user with the given id. */
  deleteMoodEntry?: Maybe<DeleteMoodEntryResponse>;
  dismissTooltip?: Maybe<Tooltip>;
  /**
   * Edits an existing journal entry for the current user with the given input.
   * It returns the edited journal entry.
   */
  editJournalEntry?: Maybe<EditJournalEntryResponse>;
  /**
   * Edits an existing mood entry for the current user with the given input.
   * It returns the edited mood entry.
   */
  editMoodEntry?: Maybe<EditMoodEntryResponse>;
  favoriteMerchant?: Maybe<FavoriteMerchantResponse>;
  joinChallenge: JoinChallengeResponse;
  joinChallengeTeam?: Maybe<JoinChallengeTeamResponse>;
  joinDigitalClinicalProgram?: Maybe<Scalars['Boolean']['output']>;
  joinGroupChallenge: JoinGroupChallengeResponse;
  leaveChallenge: LeaveChallengeResponse;
  leaveChallengeTeam?: Maybe<LeaveChallengeTeamResponse>;
  leaveDigitalClinicalProgram?: Maybe<Scalars['Boolean']['output']>;
  leaveGroupChallenge: LeaveGroupChallengeResponse;
  markAsDismissed?: Maybe<BannerResponse>;
  mockMutation?: Maybe<MockMutationResponse>;
  /**
   * Anyone in the team can remove the team image.
   * Removing the image sets it to a default one.
   */
  removeChallengeTeamImage: RemoveChallengeTeamImageResponse;
  removeGroupChallengeParticipant: RemoveGroupChallengeParticipantResponse;
  report?: Maybe<ContentReportResponse>;
  /** Allows a user who was flagged as at risk during the care journey to be contacted later with the provided contact details. */
  requestCallbackForAtRiskMember?: Maybe<RequestCallbackForAtRiskMemberResponse>;
  retakeAssessment?: Maybe<RetakeAssessmentResponse>;
  /** Retake an individual challenge once it has ended */
  retakeIndividualChallenge: RetakeIndividualChallengeResponse;
  /** Set care service option for a user. */
  selectCareServiceOption?: Maybe<SelectCareServiceOptionResponse>;
  selectCounsellor?: Maybe<SelectCounsellorResponse>;
  selectHabits?: Maybe<SelectedHabitsResponse>;
  selectInterests?: Maybe<SelectInterestsResponse>;
  /** Set care issue for a user */
  setCareIssue?: Maybe<SetCareIssueResponse>;
  /**
   * Submit feedback on a chat interaction. The traceId links the feedback
   * to a specific message exchange returned by the SSE stream.
   */
  submitChatFeedback: ChatFeedbackResponse;
  submitFeedback?: Maybe<SubmitFeedbackResponse>;
  /** Submits the user request for the global intake form. */
  submitGlobalIntakeAppointmentRequest?: Maybe<GlobalIntakeAppointmentRequestResponse>;
  trackDigitalClinicalProgramProgress?: Maybe<DigitalClinicalProgram>;
  unFavoriteMerchant?: Maybe<UnFavoriteMerchantResponse>;
  updateActivitySource?: Maybe<UpdateActivitySourceResponse>;
  /** Anyone in the team can update team details. */
  updateChallengeTeamName?: Maybe<UpdateChallengeTeamResponse>;
  /** Update properties of an existing conversation (e.g. rename its title). */
  updateConversation: UpdateConversationResponse;
  updateGroupChallenge: UpdateGroupChallengeResponse;
  updateHabitActivity?: Maybe<UpdateHabitActivityResponse>;
  updatePersonalisationPermission?: Maybe<UpdatePersonalisationPermissionResponse>;
  uploadExerciseActivity?: Maybe<UploadExerciseEventsResponse>;
  wpoCancelAppointment: WpoCancelAppointmentResponse;
  wpoCreateAppointment: WpoCreateAppointmentResponse;
};

export type MutationAnswerAssessmentQuestionsArgs = {
  request?: InputMaybe<AnswerAssessmentQuestionsInput>;
};

export type MutationAnswerPreAssessmentArgs = {
  request: AnswerPreAssessmentInput;
};

export type MutationAssignCarePlanArgs = {
  input?: InputMaybe<AssignCarePlanInput>;
};

export type MutationBookAppointmentArgs = {
  input: BookAppointmentInput;
};

export type MutationCancelAppointmentArgs = {
  input: CancelAppointmentInput;
};

export type MutationChangeGenderArgs = {
  request?: InputMaybe<ChangeGenderInput>;
};

export type MutationCompleteCarePlanActivityArgs = {
  input?: InputMaybe<CompleteCarePlanActivityInput>;
};

export type MutationCompleteCustomTierActivityArgs = {
  request?: InputMaybe<FindCustomTierActivityInput>;
};

export type MutationCompleteWalkthroughArgs = {
  request: WalkthroughTypeInput;
};

export type MutationCreateChallengeTeamArgs = {
  request: CreateChallengeTeamInput;
};

export type MutationCreateCustomMoodFactorArgs = {
  input: CreateCustomMoodFactorInput;
};

export type MutationCreateGroupChallengeArgs = {
  input: CreateGroupChallengeInput;
};

export type MutationCreateJournalEntryArgs = {
  input: CreateJournalEntryInput;
};

export type MutationCreateMoodEntryArgs = {
  input: CreateMoodEntryInput;
};

export type MutationDeleteConversationArgs = {
  sessionId: Scalars['ID']['input'];
};

export type MutationDeleteCustomMoodFactorsArgs = {
  input: DeleteCustomMoodFactorsInput;
};

export type MutationDeleteGroupChallengeArgs = {
  challengeId: Scalars['GraphQLUUID']['input'];
};

export type MutationDeleteJournalEntryArgs = {
  input: DeleteJournalEntryInput;
};

export type MutationDeleteMoodEntryArgs = {
  input: DeleteMoodEntryInput;
};

export type MutationDismissTooltipArgs = {
  request: FindTooltipInput;
};

export type MutationEditJournalEntryArgs = {
  input: EditJournalEntryInput;
};

export type MutationEditMoodEntryArgs = {
  input: EditMoodEntryInput;
};

export type MutationFavoriteMerchantArgs = {
  input?: InputMaybe<FavoriteMerchantInput>;
};

export type MutationJoinChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationJoinChallengeTeamArgs = {
  request: JoinChallengeTeamInput;
};

export type MutationJoinDigitalClinicalProgramArgs = {
  request: JoinDigitalClinicalProgramInput;
};

export type MutationJoinGroupChallengeArgs = {
  challengeId: Scalars['GraphQLUUID']['input'];
};

export type MutationLeaveChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationLeaveChallengeTeamArgs = {
  request: LeaveChallengeTeamInput;
};

export type MutationLeaveDigitalClinicalProgramArgs = {
  request: LeaveDigitalClinicalProgramInput;
};

export type MutationLeaveGroupChallengeArgs = {
  challengeId: Scalars['GraphQLUUID']['input'];
};

export type MutationMarkAsDismissedArgs = {
  input: BannerInput;
};

export type MutationMockMutationArgs = {
  input: MockMutationInput;
};

export type MutationRemoveChallengeTeamImageArgs = {
  request: RemoveChallengeTeamImageInput;
};

export type MutationRemoveGroupChallengeParticipantArgs = {
  challengeId: Scalars['GraphQLUUID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationReportArgs = {
  input: ReportInput;
};

export type MutationRequestCallbackForAtRiskMemberArgs = {
  input: RequestCallbackForAtRiskMemberInput;
};

export type MutationRetakeAssessmentArgs = {
  request?: InputMaybe<RetakeAssessmentInput>;
};

export type MutationRetakeIndividualChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationSelectCareServiceOptionArgs = {
  request: SelectCareServiceOptionInput;
};

export type MutationSelectCounsellorArgs = {
  input: SelectCounsellorInput;
};

export type MutationSelectHabitsArgs = {
  request?: InputMaybe<SelectHabitsInput>;
};

export type MutationSelectInterestsArgs = {
  input: SelectInterestsInput;
};

export type MutationSetCareIssueArgs = {
  request: SetCareIssueInput;
};

export type MutationSubmitChatFeedbackArgs = {
  input: ChatFeedbackInput;
};

export type MutationSubmitFeedbackArgs = {
  input: SubmitFeedbackInput;
};

export type MutationSubmitGlobalIntakeAppointmentRequestArgs = {
  input: GlobalIntakeAppointmentRequestInput;
};

export type MutationTrackDigitalClinicalProgramProgressArgs = {
  request: DigitalClinicalProgramInteractionInput;
};

export type MutationUnFavoriteMerchantArgs = {
  input?: InputMaybe<UnFavoriteMerchantInput>;
};

export type MutationUpdateActivitySourceArgs = {
  input: UpdateActivitySourceInput;
};

export type MutationUpdateChallengeTeamNameArgs = {
  request: UpdateChallengeTeamNameInput;
};

export type MutationUpdateConversationArgs = {
  input: UpdateConversationInput;
};

export type MutationUpdateGroupChallengeArgs = {
  input: UpdateGroupChallengeInput;
};

export type MutationUpdateHabitActivityArgs = {
  request?: InputMaybe<UpdateHabitActivityInput>;
};

export type MutationUpdatePersonalisationPermissionArgs = {
  request?: InputMaybe<UpdatePersonalisationPermissionInput>;
};

export type MutationUploadExerciseActivityArgs = {
  request: UploadExerciseEventsInput;
};

export type MutationWpoCancelAppointmentArgs = {
  input: WpoCancelAppointmentInput;
};

export type MutationWpoCreateAppointmentArgs = {
  input: WpoCreateAppointmentInput;
};

/** A navigation link suggested by an assistant message. */
export type NavigationLink = {
  __typename: 'NavigationLink';
  linkId: Scalars['ID']['output'];
  relativeUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NextTier = {
  __typename: 'NextTier';
  id?: Maybe<Scalars['ID']['output']>;
  mandatoryActivities?: Maybe<Array<Maybe<MandatoryTierActivities>>>;
  meetsRequirementsForTier?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
};

export type Offer = {
  id: Scalars['ID']['output'];
  /**
   * You can use this to get information about the merchant on this offer.
   * This is often used to get the name of the merchant.
   */
  merchant: Merchant;
  title: Scalars['String']['output'];
};

export type OffersInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FetchOffersOrder>;
  where?: InputMaybe<FetchOffersWhere>;
};

export type OffersPaginatedResponse = {
  __typename: 'OffersPaginatedResponse';
  data: Array<Offer>;
  paging?: Maybe<Pagination>;
};

export enum OffersSort {
  Alphabetical = 'alphabetical',
  EndingSoon = 'endingSoon',
  HighestCashback = 'highestCashback',
  MostPopular = 'mostPopular',
  MostSpecialOffers = 'mostSpecialOffers',
  SelectedByWa = 'selectedByWA',
}

export enum Order {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export type PageChallengeTeamsLeaderboardInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PageTierActivitiesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginatedAppointments = {
  __typename: 'PaginatedAppointments';
  data: Array<Appointment>;
  paging: Pagination;
};

export type PaginatedCarePlans = {
  __typename: 'PaginatedCarePlans';
  data: Array<CarePlan>;
  paging: Pagination;
};

export type PaginatedCounsellors = {
  __typename: 'PaginatedCounsellors';
  data?: Maybe<Array<Counsellor>>;
  paging?: Maybe<Pagination>;
};

export type PaginatedJournalEntries = {
  __typename: 'PaginatedJournalEntries';
  data: Array<JournalEntry>;
  paging: Pagination;
};

export type PaginatedMoodEntries = {
  __typename: 'PaginatedMoodEntries';
  data: Array<MoodEntry>;
  paging: Pagination;
};

export type PaginatedRecommendations = {
  __typename: 'PaginatedRecommendations';
  data: Array<Recommendation>;
  paging: Pagination;
};

export type PaginatedTierActivities = {
  __typename: 'PaginatedTierActivities';
  data?: Maybe<Array<TierActivity>>;
  paging: Pagination;
};

export type PaginatedWorkLifeServices = {
  __typename: 'PaginatedWorkLifeServices';
  data: Array<WorkLifeService>;
  paging: Pagination;
};

/** Pagination envelope shared across paginated queries. */
export type Pagination = {
  __typename: 'Pagination';
  /** Cursors to navigate to neighbouring pages. */
  cursors: PaginationCursors;
  /** True when this is the last page. */
  isLastPage: Scalars['Boolean']['output'];
  /** Page size used. */
  limit?: Maybe<Scalars['Int']['output']>;
};

/** Bidirectional cursors for paginated queries. */
export type PaginationCursors = {
  __typename: 'PaginationCursors';
  /** Cursor to fetch the next page (forward). Null when this is the last page. */
  after?: Maybe<Scalars['String']['output']>;
  /** Cursor to fetch the previous page (backward). Null when not supported. */
  before?: Maybe<Scalars['String']['output']>;
};

export type PaymentRequirementsResponse = {
  __typename: 'PaymentRequirementsResponse';
  isPaymentRequired: Scalars['Boolean']['output'];
};

export type PensionAndBenefitsSummary = {
  __typename: 'PensionAndBenefitsSummary';
  benefits?: Maybe<BenefitsSummary>;
  notifications?: Maybe<PensionsAndBenefitsNotificationSummary>;
  pension?: Maybe<PensionSummary>;
  title: Scalars['String']['output'];
};

export type PensionAndBenefitsTemporaryUrl = {
  __typename: 'PensionAndBenefitsTemporaryUrl';
  expiry: Scalars['GraphQLDateTime']['output'];
  url: Scalars['String']['output'];
};

export type PensionAndBenefitsTotal = {
  __typename: 'PensionAndBenefitsTotal';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PensionSummary = {
  __typename: 'PensionSummary';
  portalUrlId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totals?: Maybe<Array<PensionAndBenefitsTotal>>;
};

export type PensionsAndBenefitsNotification = {
  __typename: 'PensionsAndBenefitsNotification';
  details: Scalars['String']['output'];
  expiryDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  portalUrlId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PensionsAndBenefitsNotificationSummary = {
  __typename: 'PensionsAndBenefitsNotificationSummary';
  count: Scalars['Int']['output'];
  items?: Maybe<Array<PensionsAndBenefitsNotification>>;
};

export type PerksCategoriesInput = {
  includeFavorites?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PerksType>;
};

export type PerksCategoriesResponse = {
  __typename: 'PerksCategoriesResponse';
  categories: Array<PerksCategory>;
};

export type PerksCategory = {
  __typename: 'PerksCategory';
  icon?: Maybe<Image>;
  id: Scalars['ID']['output'];
  /** Localized name of the category. */
  name: Scalars['String']['output'];
};

/** A section combining a title and a detail of rich text. */
export type PerksFormattedTextSection = {
  __typename: 'PerksFormattedTextSection';
  detail: FormattedText;
  id: Scalars['ID']['output'];
  title: FormattedText;
};

export enum PerksType {
  Cashback = 'cashback',
}

export type PreAssessmentHistoryPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PreAssessmentNotTaken = {
  __typename: 'PreAssessmentNotTaken';
  /** A unique identifier for the assessment. Is also used for tracking in google analytics. */
  id: Scalars['ID']['output'];
  /**
   * A unique value that is used to track responses when this assessment is retaken on its own
   * This sessionId is then used in calls to the preAssessment query and answerPreAssessment mutation
   */
  sessionId: Scalars['String']['output'];
  /** Localized title of the result. */
  title: Scalars['String']['output'];
};

export type PreAssessmentRecommendation =
  | PreAssessmentRecommendationBookAppointment
  | PreAssessmentRecommendationSuicideRiskCallNow;

export type PreAssessmentRecommendationBookAppointment = {
  __typename: 'PreAssessmentRecommendationBookAppointment';
  id: Scalars['ID']['output'];
};

export type PreAssessmentRecommendationSuicideRiskCallNow = {
  __typename: 'PreAssessmentRecommendationSuicideRiskCallNow';
  ccsTeamTelephoneNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PreAssessmentResponse = {
  __typename: 'PreAssessmentResponse';
  /** The next assessment in the pre assessment sequence. Null if there are no more asseessments remaining for pre assessment. */
  nextAssessment?: Maybe<CareAssessment>;
};

export type PreAssessmentResult = {
  __typename: 'PreAssessmentResult';
  /** The UTC Datetime that the PreAssessment was completed. */
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** Localized description of the result. */
  description: Scalars['String']['output'];
  /**
   * The lower bound of the last range in list of severities
   * This FEs uses this to aid in creating bar graphs
   */
  displayMaxScore: Scalars['Int']['output'];
  /** A unique identifier for the assessment. Is also used for tracking in google analytics. */
  id: Scalars['ID']['output'];
  /** Maximum possible score a user can have. */
  maxScore: Scalars['Int']['output'];
  /** Contains information related to when the user should retake the assessment based on clinical recommendation. */
  retakeData: RetakeData;
  /** Score. */
  score: Scalars['Int']['output'];
  /**
   * A unique value that is used to track responses when this assessment is retaken on its own
   * This sessionId is then used in calls to the preAssessment query and answerPreAssessment mutation
   */
  sessionId: Scalars['String']['output'];
  /**
   * Localized list of possible severities for this result.
   * Ordered from low to high.
   * NOTE: The list of severities is not consistent across all assessments.
   */
  severities: Array<Scalars['String']['output']>;
  /** Localized title of the result. */
  title: Scalars['String']['output'];
};

export type PreAssessmentResults = {
  __typename: 'PreAssessmentResults';
  /** Returns the assessments that the user has completed or not taken yet. */
  assessments: Array<PreAssessmentStatus>;
  /**
   * If true FE must display the "Speak to counsellor"
   * @deprecated Use shouldSpeakToCounsellor
   */
  displaySpeakToCounsellorMessage: Scalars['Boolean']['output'];
  /** Indicates if the user should speak to a counsellor based on their score. */
  shouldSpeakToCounsellor: Scalars['Boolean']['output'];
  /**
   * Returns the assessments that have been completed.
   * @deprecated We now want to include assessments the user has not taken yet. This will always return completed assessment to keep backwards compatability
   */
  summary: Array<PreAssessmentResult>;
};

export type PreAssessmentResultsHistoryResponse = {
  __typename: 'PreAssessmentResultsHistoryResponse';
  history?: Maybe<Array<Maybe<PreAssessmentResult>>>;
  pagination: Pagination;
};

export type PreAssessmentResultsResponse = {
  __typename: 'PreAssessmentResultsResponse';
  /**
   * When `true` indicates the user has one or more assessments for which time to retake has come.
   * This is related to `RetakeData.earlyRetakeWarningMessage`.
   */
  isTimeToRetakeAssessments: Scalars['Boolean']['output'];
  results: PreAssessmentResults;
};

/** This union represents assessments that the user has completed (has a result) or assessments the user has not taken yet. */
export type PreAssessmentStatus = PreAssessmentNotTaken | PreAssessmentResult;

export enum PreferredMeridiem {
  Am = 'AM',
  Pm = 'PM',
}

export enum PromotionType {
  Assessment = 'ASSESSMENT',
  CorporateChallenge = 'CORPORATE_CHALLENGE',
  /** @deprecated Legacy type */
  Hra = 'HRA',
  TotalHealthIndex = 'TOTAL_HEALTH_INDEX',
}

export type Query = {
  __typename: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `fetchAssessments`. */
  allAssessments?: Maybe<Array<AssessmentListItem>>;
  /** @deprecated Use `digitalClinicalPrograms`. */
  allDigitalClinicalPrograms: Array<DigitalClinicalProgram>;
  allTierActivities?: Maybe<PaginatedTierActivities>;
  allTiers?: Maybe<Array<TierDefinition>>;
  /**
   * Obtain the payment setup intent so the user can proceed with the payment flow on the FE.
   * Expected for BE to generate the Stripe payment intent and associate it with the current logged in user.
   */
  appointmentPaymentSetupIntent?: Maybe<AppointmentPaymentSetupIntentResponse>;
  /**
   * If the user was assessed as at suicide risk, the ccsTelephoneNumber is returned so the at risk card can be displayed
   * Otherwise null is returned.
   */
  assessedAsSuicideRisk?: Maybe<AssessedAsSuicideRiskResponse>;
  assessment?: Maybe<AssessmentListItem>;
  assessmentHeroCards?: Maybe<Array<AssessmentHeroCard>>;
  assessmentHistory?: Maybe<Array<Maybe<AssessmentItemHistory>>>;
  /** @deprecated Use `wellbeingPromotions`. */
  assessmentPromotions?: Maybe<Array<AssessmentPromotion>>;
  assessmentTierPoints: AssessmentTierPoints;
  assessmentTypeFilters?: Maybe<Array<AssessmentTypeFilter>>;
  /** The care plans available for the user to select. */
  availableCarePlans?: Maybe<AvailableCarePlansResponse>;
  /** Retrieves the available mood factors that the user can select. */
  availableMoodFactors?: Maybe<AvailableMoodFactorsResponse>;
  averageDailyMoodInsights?: Maybe<AverageDailyMoodInsightsResponse>;
  banner?: Maybe<BannerResponse>;
  /** The care plan currently assigned to the user. */
  carePlan?: Maybe<CarePlanResponse>;
  /** Whenever an activity is retrieved from the server, it will be set as the current activity. */
  carePlanActivity?: Maybe<CarePlanActivityResponse>;
  /** @deprecated Use `wellbeingPromotions`. */
  challengePromotions?: Maybe<Array<ChallengePromotion>>;
  /** Returns the chat details necessary to initialize an AWS Connect Chat session in the FE based on the current logged in user and the input given. */
  connectChatInitialization?: Maybe<ConnectChatInitializationResponse>;
  /**
   * Get paginated messages for a conversation owned by the authenticated user.
   * The sessionId comes from `conversations.data[].sessionId` or the
   * TH1-Session-Id response header on /message.
   */
  conversationMessages: ConversationMessagesResponse;
  /**
   * List the authenticated user's past conversations, paginated using
   * the standard pagination envelope.
   */
  conversations: ConversationsResponse;
  currentTier?: Maybe<CurrentTier>;
  customTierActivities?: Maybe<Array<CustomTierActivity>>;
  customTierActivity?: Maybe<CustomTierActivity>;
  /**
   * We have to rename this query to fix a duplicate error before just removing the subgraph
   * and schema from offers API entirely
   */
  deprecatedPerksCategories?: Maybe<PerksCategoriesResponse>;
  digitalClinicalModule?: Maybe<DigitalClinicalModule>;
  digitalClinicalProgram?: Maybe<DigitalClinicalProgram>;
  digitalClinicalProgramCategories?: Maybe<
    Array<Maybe<DigitalClinicalProgramCategory>>
  >;
  digitalClinicalProgramCategory?: Maybe<DigitalClinicalProgramCategory>;
  digitalClinicalPrograms?: Maybe<Array<DigitalClinicalProgramListItem>>;
  encourageEarningTierPoints?: Maybe<TierEncouragement>;
  /** @deprecated Use `assessmentHeroCards`. */
  featuredAssessments?: Maybe<Array<FeaturedAssessment>>;
  /** Asks for the feedback request for a given feedback id. */
  feedbackRequest?: Maybe<FeedbackRequestResponse>;
  fetchAppointmentById?: Maybe<FetchAppointmentResponse>;
  fetchAppointments?: Maybe<FetchAppointmentsResponse>;
  fetchAssessments?: Maybe<FetchAssessmentsResponse>;
  fetchChallenge: FetchChallengeResponse;
  fetchChallengeTeam?: Maybe<FetchTeamResponse>;
  fetchChallenges?: Maybe<FetchChallengesResponse>;
  fetchCounsellor?: Maybe<FetchCounsellorResponse>;
  fetchCounsellorById?: Maybe<FetchCounsellorResponse>;
  fetchCounsellorFilters?: Maybe<FetchCounsellorFiltersResponse>;
  fetchCounsellors?: Maybe<FetchCounsellorsResponse>;
  fetchFeaturedChallenges?: Maybe<FetchFeaturedChallengesResponse>;
  fetchFirstOfferedAvailableTimeSlot?: Maybe<FetchFirstOfferedAvailableTimeSlotResponse>;
  fetchTransaction: FetchTransactionResult;
  fetchUserSubdivisions?: Maybe<FetchUserSubdivisionsResponse>;
  getActivitySource?: Maybe<GetActivitySourceResponse>;
  getAssessment?: Maybe<AssessmentListItem>;
  /** Get the list of all the available CareIssues */
  getCareIssues?: Maybe<CareIssuesResponse>;
  /**
   * Returns a paginated teams leaderboard for a specific date
   * If the corporate challenge has not started the teams will
   * be returned in alphabetical order without a score.
   * Once the corporate challenge is in progress the list will
   * be a leaderboard showing which team is currently winning.
   * The leaderboard is ordered by the team's score.
   * The team's score is a median of each team member's score.
   * If the user's team is on the first page then we prepend
   * the team to the top of the list
   * @deprecated Use `leaderboardTeams` field on `StepChallenge` or `HabitChallenge`.
   */
  getChallengeTeamsLeaderboard?: Maybe<GetChallengeTeamsLeaderboardResponse>;
  /** Get localized feedback reason options to present to the user */
  getFeedbackReasons: FeedbackReasonsResponse;
  getGroupChallenge: GetGroupChallengeResponse;
  getHowItWorks: GetHowItWorksResponse;
  getHra?: Maybe<FeaturedAssessment>;
  /** Get suggested prompts for the chat interface */
  getSuggestedPrompts: SuggestedPromptsResponse;
  getWalkthrough: Walkthrough;
  /** Everything the create-a-group-challenge screen needs before it can be drawn */
  groupChallengeConfig: GroupChallengeConfig;
  historicalAssessment?: Maybe<HistoricalAssessment>;
  /** Get content and settings that describe personalisation and the users current privacy settings */
  howDoesPersonalisationWork?: Maybe<HowDoesPersonalisationWorkResponse>;
  howToEarnTierPoints?: Maybe<Array<HowToEarnTierPoints>>;
  /** @deprecated Use `wellbeingPromotions`. */
  hraPromotion?: Maybe<HraPromotion>;
  influencesMoodInsights?: Maybe<InfluencesMoodInsightsResponse>;
  /** Returns all the available interests the user can select. */
  interests?: Maybe<InterestsResponse>;
  /**
   * Retrieves the journal entries for the current user.
   * Note: Ordered from most recent to oldest.
   */
  journalEntries?: Maybe<JournalEntriesResponse>;
  listGroupChallenges: ListGroupChallengesResponse;
  /** Get a greeting message for the member assistant */
  memberAssistGreeting: GreetingResponse;
  /** A specific Perks Merchant */
  merchant?: Maybe<MerchantResponse>;
  /** Perks Merchants */
  merchants?: Maybe<FetchMerchantsResponse>;
  /**
   * Retrieves the mood entries for the current user.
   * Note: Ordered from most recent to oldest.
   */
  moodEntries?: Maybe<MoodEntriesResponse>;
  nextTier?: Maybe<NextTier>;
  offers?: Maybe<FetchOffersResponse>;
  /** Contains flag specifying whether current user needs to input card information */
  paymentRequirements?: Maybe<PaymentRequirementsResponse>;
  pensionAndBenefitsPortalUrl?: Maybe<PensionAndBenefitsTemporaryUrl>;
  pensionAndBenefitsSummary?: Maybe<PensionAndBenefitsSummary>;
  perksCategories?: Maybe<PerksCategoriesResponse>;
  /**
   * Returns the next PreAssessment based on any that may have been previously answered
   *
   * A specific assessment may be fetched by supplying the FilterPreAssessmentInput parameter
   *
   * The `retake` field in FilterPreAssessmentInput allows the user to retake assessments by
   * restarting the assessment flow
   */
  preAssessment?: Maybe<PreAssessmentResponse>;
  /**
   * Returns the user's most recent pre-assessment results.
   * If the user has not completed the pre-assessments as yet, then an empty response is returned
   */
  preAssessmentResults?: Maybe<PreAssessmentResultsResponse>;
  /**
   * Returns the user's recent pre-assessment results for a specific assessment.
   * The results are ordered from most recent to least recent
   */
  preAssessmentResultsHistory?: Maybe<PreAssessmentResultsHistoryResponse>;
  /**
   * Return the recommendations for teh user based in their selected interests.
   * Sorted by highest priority first.
   */
  recommendations?: Maybe<RecommendationsResponse>;
  /**
   * Get recommended articles for the user. ML recommendations may be used depending on company fks
   * and the users personalisation preferences.
   */
  recommendedArticles?: Maybe<RecommendedArticlesResponse>;
  /**
   * Search the authenticated user's past conversations by title.
   * Returns conversations whose title contains the query string (case-insensitive substring match).
   */
  searchConversations: ConversationsResponse;
  /** Get the card previously selected by the user */
  selectedCard?: Maybe<SelectedCardResponse>;
  /** Get the user selected care service option. */
  selectedCareServiceOption?: Maybe<SelectedCareServiceOptionResponse>;
  /** Get the credentials needed to initialize Stripe FE SDKs. */
  stripeInitialization?: Maybe<StripeInitializationResponse>;
  tierPoints?: Maybe<TierPoints>;
  tierRegressionInfo?: Maybe<TierRegressionInfo>;
  tmhWpoAppointmentsHealthCheck: TmhWpoAppointmentsHealthCheckResponse;
  tooltip?: Maybe<Tooltip>;
  totalHealthIndexResult: TotalHealthIndexResult;
  wellbeingContentLanguageMessage?: Maybe<WellbeingContentLanguageMessageResponse>;
  wellbeingPromotions?: Maybe<Array<WellbeingPromotion>>;
  /** The Work Life services that the logged in user is entitled to access. */
  workLifeServices?: Maybe<WorkLifeServicesResponse>;
  wpoGetAppointmentHistory: WpoGetAppointmentHistoryResponse;
  wpoGetAvailableCounsellors: WpoGetAvailableCounsellorsResponse;
  wpoGetAvailableTimeSlots: WpoAvailableDateTimeSlotsResponse;
  wpoGetFilters: WpoGetFiltersResponse;
  wpoGetUpcomingAppointment?: Maybe<WpoGetUpcomingAppointmentResponse>;
  wpoUserHasUpcomingAppointment: WpoUserHasUpcomingAppointment;
};

export type QueryAllAssessmentsArgs = {
  where?: InputMaybe<FilterAssessmentsInput>;
};

export type QueryAllTierActivitiesArgs = {
  select?: InputMaybe<PageTierActivitiesInput>;
};

export type QueryAssessmentArgs = {
  requestGlobalContent?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FindAssessmentInput>;
};

export type QueryAssessmentHeroCardsArgs = {
  requestGlobalContent?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FilterAssessmentsInput>;
};

export type QueryAssessmentHistoryArgs = {
  where?: InputMaybe<FindAssessmentHistoryInput>;
};

export type QueryAvailableCarePlansArgs = {
  input?: InputMaybe<AvailableCarePlansInput>;
};

export type QueryAverageDailyMoodInsightsArgs = {
  input?: InputMaybe<AverageDailyMoodInsightsInput>;
};

export type QueryBannerArgs = {
  input: BannerInput;
};

export type QueryCarePlanActivityArgs = {
  where?: InputMaybe<CarePlanActivityInput>;
};

export type QueryConnectChatInitializationArgs = {
  input: ConnectChatInitializationInput;
};

export type QueryConversationMessagesArgs = {
  input?: InputMaybe<ConversationMessagesInput>;
  sessionId: Scalars['ID']['input'];
};

export type QueryConversationsArgs = {
  input?: InputMaybe<ConversationsInput>;
};

export type QueryCustomTierActivityArgs = {
  where?: InputMaybe<FindCustomTierActivityInput>;
};

export type QueryDeprecatedPerksCategoriesArgs = {
  input: PerksCategoriesInput;
};

export type QueryDigitalClinicalModuleArgs = {
  where: FindDigitalClinicalModuleInput;
};

export type QueryDigitalClinicalProgramArgs = {
  where: FindDigitalClinicalProgramInput;
};

export type QueryDigitalClinicalProgramCategoryArgs = {
  where: FindDigitalClinicalCategoryInput;
};

export type QueryDigitalClinicalProgramsArgs = {
  select?: InputMaybe<SliceDigitalClinicalProgramsInput>;
  where?: InputMaybe<FilterDigitalClinicalProgramsInput>;
};

export type QueryFeaturedAssessmentsArgs = {
  where?: InputMaybe<FilterAssessmentsInput>;
};

export type QueryFeedbackRequestArgs = {
  input: FeedbackRequestInput;
};

export type QueryFetchAppointmentByIdArgs = {
  input: FetchAppointmentByIdInput;
};

export type QueryFetchAppointmentsArgs = {
  input?: InputMaybe<FetchAppointmentsInput>;
};

export type QueryFetchAssessmentsArgs = {
  requestGlobalContent?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FilterAssessmentsInput>;
};

export type QueryFetchChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFetchChallengeTeamArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFetchChallengesArgs = {
  select?: InputMaybe<SliceChallengesInput>;
  where?: InputMaybe<FilterChallengesInput>;
};

export type QueryFetchCounsellorByIdArgs = {
  input: FetchCounsellorByIdInput;
};

export type QueryFetchCounsellorFiltersArgs = {
  input?: InputMaybe<FetchCounsellorFiltersInput>;
};

export type QueryFetchCounsellorsArgs = {
  input: FetchCounsellorsInput;
};

export type QueryFetchFeaturedChallengesArgs = {
  where?: InputMaybe<FilterChallengesInput>;
};

export type QueryFetchFirstOfferedAvailableTimeSlotArgs = {
  input?: InputMaybe<FetchFirstOfferedAppointmentInput>;
};

export type QueryFetchTransactionArgs = {
  transaction_id: Scalars['ID']['input'];
};

export type QueryGetAssessmentArgs = {
  assessmentId: Scalars['ID']['input'];
};

export type QueryGetCareIssuesArgs = {
  where?: InputMaybe<GetCareIssuesInput>;
};

export type QueryGetChallengeTeamsLeaderboardArgs = {
  select?: InputMaybe<PageChallengeTeamsLeaderboardInput>;
  where?: InputMaybe<FindChallengeTeamsLeaderboardInput>;
};

export type QueryGetFeedbackReasonsArgs = {
  input?: InputMaybe<FeedbackReasonsInput>;
};

export type QueryGetGroupChallengeArgs = {
  challengeId: Scalars['GraphQLUUID']['input'];
};

export type QueryGetHowItWorksArgs = {
  input?: InputMaybe<GetHowItWorksInput>;
};

export type QueryGetSuggestedPromptsArgs = {
  input?: InputMaybe<SuggestedPromptsInput>;
};

export type QueryGetWalkthroughArgs = {
  where?: InputMaybe<WalkthroughTypeInput>;
};

export type QueryHistoricalAssessmentArgs = {
  where?: InputMaybe<FindHistoricalAssessmentInput>;
};

export type QueryInfluencesMoodInsightsArgs = {
  input?: InputMaybe<InfluencesMoodInsightsInput>;
};

export type QueryJournalEntriesArgs = {
  input: JournalEntriesInput;
};

export type QueryListGroupChallengesArgs = {
  listGroupChallengesInput?: InputMaybe<ListGroupChallengesInput>;
};

export type QueryMemberAssistGreetingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type QueryMerchantArgs = {
  input: MerchantInput;
};

export type QueryMerchantsArgs = {
  input: MerchantsInput;
};

export type QueryMoodEntriesArgs = {
  input: MoodEntriesInput;
};

export type QueryOffersArgs = {
  input: OffersInput;
};

export type QueryPensionAndBenefitsPortalUrlArgs = {
  id: Scalars['String']['input'];
};

export type QueryPerksCategoriesArgs = {
  input: PerksCategoriesInput;
};

export type QueryPreAssessmentArgs = {
  where?: InputMaybe<FilterPreAssessmentInput>;
};

export type QueryPreAssessmentResultsHistoryArgs = {
  where?: InputMaybe<FilterPreAssessmentHistoryInput>;
};

export type QueryRecommendationsArgs = {
  input: RecommendationsInput;
};

export type QueryRecommendedArticlesArgs = {
  select?: InputMaybe<SliceRecommendedArticlesInput>;
};

export type QuerySearchConversationsArgs = {
  input: SearchConversationsInput;
};

export type QueryTooltipArgs = {
  where: FindTooltipInput;
};

export type QueryWellbeingContentLanguageMessageArgs = {
  section: WellbeingContentLanguageMessageSection;
};

export type QueryWorkLifeServicesArgs = {
  input: WorkLifeServicesInput;
};

export type QueryWpoGetAppointmentHistoryArgs = {
  input: WpoGetAppointmentHistoryInput;
};

export type QueryWpoGetAvailableCounsellorsArgs = {
  input: WpoGetAvailableCounsellorsInput;
};

export type QueryWpoGetAvailableTimeSlotsArgs = {
  input: WpoGetAvailableTimeSlotsInput;
};

export type QueryWpoGetFiltersArgs = {
  input?: InputMaybe<WpoGetFiltersInput>;
};

export type QueryWpoGetUpcomingAppointmentArgs = {
  input?: InputMaybe<WpoGetUpcomingAppointmentInput>;
};

export type QueryWpoUserHasUpcomingAppointmentArgs = {
  input?: InputMaybe<WpoUserHasUpcomingAppointmentInput>;
};

export enum QuestionnaireQuestionType {
  MultipleChoice = 'MultipleChoice',
  SingleChoice = 'SingleChoice',
  UnitsOfMeasurements = 'UnitsOfMeasurements',
}

export type Recommendation = {
  __typename: 'Recommendation';
  id: Scalars['ID']['output'];
  /**
   * The actual payload for this recommendation.
   * It's one of the supported types in the graph that can be recommended.
   */
  payload: RecommendationPayload;
};

export type RecommendationPayload = DigitalClinicalProgramListItem;

export type RecommendationsInput = {
  /** Pagination. Item ID after which to return new elements. */
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  /** Pagination. Number of items to return. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type RecommendationsResponse = {
  __typename: 'RecommendationsResponse';
  recommendations?: Maybe<PaginatedRecommendations>;
};

export type RecommendedArticlesResponse = {
  __typename: 'RecommendedArticlesResponse';
  /** only returned if the user has eap_self_assessment, eap_assistance, enhanced_personalisation, assessments_article_recommendations_carousel fks */
  recommendations?: Maybe<Array<Article>>;
};

export type RemainingAssessmentsCompletionPoints = {
  __typename: 'RemainingAssessmentsCompletionPoints';
  bonusPoints?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  resetDate?: Maybe<Scalars['GraphQLDateTime']['output']>;
  type?: Maybe<AssessmentGroupType>;
};

export type RemoveChallengeTeamImageInput = {
  challengeId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type RemoveChallengeTeamImageResponse = {
  __typename: 'RemoveChallengeTeamImageResponse';
  team: Team;
};

export type RemoveGroupChallengeParticipantResponse = {
  __typename: 'RemoveGroupChallengeParticipantResponse';
  challenge?: Maybe<GroupChallenge>;
};

export type ReportInput = {
  /**
   * Identifier of the target object target of the report
   * (ex: post id, comment id or profile id)
   */
  targetId: Scalars['ID']['input'];
  /** The kind of target for the report (post, comment...) */
  targetKind: ReportTargetKind;
};

export enum ReportTargetKind {
  FeedComment = 'FEED_COMMENT',
  FeedPost = 'FEED_POST',
  Profile = 'PROFILE',
}

export type RequestCallbackForAtRiskMemberInput = {
  /** User's preferred telephone number. */
  telephoneNumber: Scalars['String']['input'];
};

export type RequestCallbackForAtRiskMemberResponse = {
  __typename: 'RequestCallbackForAtRiskMemberResponse';
  telephoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ResultFeedback = Feedback & {
  __typename: 'ResultFeedback';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type RetakeData = {
  __typename: 'RetakeData';
  /**
   * Localized text to inform the user when they shouldn't retake the assessment since not enough time has passed.
   * The BE will do the check and it will only populate this field with the message only when not enough time has passed otherwise it will be null.
   */
  earlyRetakeWarningMessage?: Maybe<Scalars['String']['output']>;
};

export type RetakeIndividualChallengeResponse = {
  __typename: 'RetakeIndividualChallengeResponse';
  challenge?: Maybe<Challenge>;
};

export type ScalePoint = {
  __typename: 'ScalePoint';
  isDefault: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  scalePointId: Scalars['ID']['output'];
};

export type ScaleQuestion = {
  __typename: 'ScaleQuestion';
  contentItemId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  scale: Array<ScalePoint>;
  title: Scalars['String']['output'];
  userInteraction?: Maybe<ScaleQuestionInteraction>;
};

export type ScaleQuestionInteraction = {
  __typename: 'ScaleQuestionInteraction';
  scalePointId?: Maybe<Scalars['ID']['output']>;
  seenByUser: Scalars['Boolean']['output'];
};

export type ScaleQuestionInteractionInput = {
  contentItemId: Scalars['ID']['input'];
  scalePointId?: InputMaybe<Scalars['ID']['input']>;
  seenByUser: Scalars['Boolean']['input'];
};

/** Input for searching conversations by title (case-insensitive substring match). */
export type SearchConversationsInput = {
  /** Opaque cursor returned in the previous response's paging.cursors.after. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Max items per page (1–100). Defaults to upstream default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Sort direction. Defaults to DESC (newest first). */
  order?: InputMaybe<ConversationsOrderInput>;
  /** Substring to match against conversation titles. Case-insensitive. 1–200 chars (validated upstream). */
  query: Scalars['String']['input'];
};

export type SelectCareServiceOptionInput = {
  option: CareServiceOption;
};

export type SelectCareServiceOptionResponse = {
  __typename: 'SelectCareServiceOptionResponse';
  option: CareServiceOption;
};

export type SelectCounsellorInput = {
  counsellorId: Scalars['ID']['input'];
};

export type SelectCounsellorResponse = {
  __typename: 'SelectCounsellorResponse';
  counsellor: Counsellor;
};

export type SelectHabitCaption = {
  __typename: 'SelectHabitCaption';
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SelectHabitsData = {
  habitId: Scalars['String']['input'];
  selected: Scalars['Boolean']['input'];
};

/** templateId optional for backward compatibility, will be required in future versions */
export type SelectHabitsInput = {
  challengeId: Scalars['String']['input'];
  habits: Array<SelectHabitsData>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type SelectInterestsInput = {
  /** ID of the `InterestGroup` the user has decided to focus on. */
  group: Scalars['String']['input'];
  /** IDs of all the `Interest` the user has selected. */
  interests: Array<Scalars['String']['input']>;
};

export type SelectInterestsResponse = {
  __typename: 'SelectInterestsResponse';
  /** The immediate recommendation to give to the user after they have selected the interests. */
  immediateRecommendation?: Maybe<Recommendation>;
  interests: InterestsResponse;
};

export type SelectedCard = {
  __typename: 'SelectedCard';
  cardBrand: CardBrand;
  /** Stripe returns the expiration month as a Integer, just forward that to FEs */
  expirationMonth: Scalars['Int']['output'];
  /** Stripe returns the expiration year as a Integer, just forward that to FEs */
  expirationYear: Scalars['Int']['output'];
  /** If expiration date is before today return true, false otherwise. Card is valid until last day of the month */
  isExpired: Scalars['Boolean']['output'];
  last4Digits: Scalars['String']['output'];
};

export type SelectedCardResponse = {
  __typename: 'SelectedCardResponse';
  /** This should return the last selected user's card, or null if no card was added yet */
  selectedCard?: Maybe<SelectedCard>;
};

export type SelectedCareServiceOptionResponse = {
  __typename: 'SelectedCareServiceOptionResponse';
  option: CareServiceOption;
};

export type SelectedHabitsResponse = {
  __typename: 'SelectedHabitsResponse';
  habits: Array<Habit>;
};

export type SetCareIssueInput = {
  /** The id of the CareIssue to set for the the user. */
  id: Scalars['ID']['input'];
};

export type SetCareIssueResponse = {
  __typename: 'SetCareIssueResponse';
  careIssue: CareIssue;
};

export type SingleAssessmentCard = {
  __typename: 'SingleAssessmentCard';
  assessment: AssessmentListItem;
  completedAt?: Maybe<Scalars['GraphQLDateTime']['output']>;
  heroCardId: Scalars['String']['output'];
  icon?: Maybe<Image>;
  introduction: Scalars['String']['output'];
  status: AssessmentStatus;
  tierPoints?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type SliceChallengesInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type SliceDigitalClinicalProgramsInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type SliceRecommendedArticlesInput = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum SourceDevice {
  Fitbit = 'FITBIT',
  Googlefit = 'GOOGLEFIT',
  Healthconnect = 'HEALTHCONNECT',
  Healthkit = 'HEALTHKIT',
  Manual = 'MANUAL',
  None = 'NONE',
}

export type StarRating = {
  __typename: 'StarRating';
  isDefault: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  starRatingId: Scalars['ID']['output'];
};

export type StarRatingQuestion = {
  __typename: 'StarRatingQuestion';
  contentItemId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  starRatings: Array<StarRating>;
  title: Scalars['String']['output'];
  userInteraction?: Maybe<StarRatingQuestionInteraction>;
};

export type StarRatingQuestionInteraction = {
  __typename: 'StarRatingQuestionInteraction';
  seenByUser: Scalars['Boolean']['output'];
  starRatingId?: Maybe<Scalars['ID']['output']>;
};

export type StarRatingQuestionInteractionInput = {
  contentItemId: Scalars['ID']['input'];
  seenByUser: Scalars['Boolean']['input'];
  starRatingId?: InputMaybe<Scalars['ID']['input']>;
};

export type StepActivity = {
  __typename: 'StepActivity';
  durationInMs?: Maybe<Scalars['Int']['output']>;
  emoji?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  /** @deprecated Location tracking has been removed. */
  location?: Maybe<StepActivityLocation>;
  startedAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExerciseActivityType>;
};

export type StepActivityLocation = {
  __typename: 'StepActivityLocation';
  name?: Maybe<Scalars['String']['output']>;
};

export type StepActivityResponse = {
  __typename: 'StepActivityResponse';
  activity?: Maybe<Array<StepDailyActivity>>;
  pagination?: Maybe<Pagination>;
  summary?: Maybe<Array<EndOfChallengeSummaryTotal>>;
};

export enum StepActivityType {
  DailyTotal = 'DailyTotal',
  EndOfChallengeTotal = 'EndOfChallengeTotal',
}

export type StepChallenge = {
  __typename: 'StepChallenge';
  activityTracking?: Maybe<ChallengeActivityTracking>;
  category: ChallengeCategory;
  categoryDisplayText: Scalars['String']['output'];
  /** Extended from challenge-api */
  challengeId: Scalars['ID']['output'];
  challengeType?: Maybe<ChallengeType>;
  completionReward?: Maybe<TierReward>;
  defaultPromotionalPost?: Maybe<Scalars['String']['output']>;
  durationInDays?: Maybe<Scalars['Int']['output']>;
  endDateTimeISO?: Maybe<Scalars['GraphQLDateTime']['output']>;
  goal: Scalars['Int']['output'];
  image?: Maybe<Image>;
  introduction?: Maybe<Array<Maybe<ChallengeIntroduction>>>;
  lastUploaded?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /**
   * Returns a paginated individuals leaderboard for a specific
   * date. The leaderboard includes everyone in the company
   * who is participating in the challenge.
   * If the corporate challenge has not started the users
   * will be returned in alphabetical order without a score.
   * Once the corporate challenge is in progress the list will
   * be a leaderboard showing which user is currently winning.
   * The leaderboard is ordered by every user's score.
   */
  leaderboardIndividuals: LeaderboardIndividualResponse;
  /**
   * Returns a paginated teams leaderboard for a specific date
   * If the corporate challenge has not started the teams will
   * be returned in alphabetical order without a score.
   * Once the corporate challenge is in progress the list will
   * be a leaderboard showing which team is currently winning.
   * The leaderboard is ordered by the team's score.
   * The team's score is an average of active team members' scores.
   * If the user's team is on the first page then we prepend
   * the team to the top of the list
   */
  leaderboardTeams: LeaderboardTeamResponse;
  participant?: Maybe<ChallengeParticipant>;
  participants?: Maybe<Scalars['Int']['output']>;
  participationType: ChallengeParticipationType;
  participationTypeDisplayText: Scalars['String']['output'];
  result?: Maybe<ChallengeResult>;
  startDateTimeISO?: Maybe<Scalars['GraphQLDateTime']['output']>;
  status: ChallengeStatus;
  stepActivity: StepActivityResponse;
  subtitle?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Scalars['Int']['output']>;
  templateId: Scalars['ID']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userTeamMembership: UserTeamMembershipResponse;
  /** Indicates if the current user is actively in the challenge */
  wasJoined: Scalars['Boolean']['output'];
};

export type StepChallengeLeaderboardIndividualsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type StepChallengeLeaderboardTeamsArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type StepChallengeStepActivityArgs = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['GraphQLDate']['input']>;
};

export type StepDailyActivity = {
  __typename: 'StepDailyActivity';
  activity?: Maybe<Array<StepActivity>>;
  date: Scalars['GraphQLDate']['output'];
  id: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  tierReward?: Maybe<ChallengeDailyReward>;
  tracked: Scalars['Int']['output'];
  type: StepActivityType;
};

export type StripeInitialization = {
  __typename: 'StripeInitialization';
  publishableKey: Scalars['String']['output'];
};

/** Generic Initialization for Stripe SDKs */
export type StripeInitializationResponse = {
  __typename: 'StripeInitializationResponse';
  stripeInitialization: StripeInitialization;
};

/** Stripe Setup Intent used to start the Checkout form. */
export type StripeSetupIntent = {
  __typename: 'StripeSetupIntent';
  customerEphemeralKey: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerSessionClientSecret: Scalars['String']['output'];
  intentClientSecret: Scalars['String']['output'];
};

export type Subdivision = {
  __typename: 'Subdivision';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SubmitFeedbackInput = {
  id: FeedbackId;
  /** Number of stars selected by the user. */
  rating: Scalars['Int']['input'];
  /** Content of the free text input entered by the user. */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitFeedbackResponse = {
  __typename: 'SubmitFeedbackResponse';
  /** Just some property to make the response compliant. */
  id: FeedbackId;
};

/** A single suggested prompt */
export type SuggestedPrompt = {
  __typename: 'SuggestedPrompt';
  label: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  promptCategory: Scalars['String']['output'];
};

/** Input for suggested prompts query */
export type SuggestedPromptsInput = {
  /**
   * Locale for localization (e.g. en-ca, en_CA, fr-ca;q=0.9).
   * Normalized internally to lowercase hyphenated format.
   */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Number of suggested prompts to return. Defaults to 4. */
  promptCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Response containing a list of suggested prompts */
export type SuggestedPromptsResponse = {
  __typename: 'SuggestedPromptsResponse';
  suggestedPrompts: Array<SuggestedPrompt>;
};

export enum TargetType {
  Daily = 'Daily',
  Total = 'Total',
}

export type Team = {
  __typename: 'Team';
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns a paginated leaderboard of members for a team
   * If the corporate challenge has not started the members
   * will be returned in alphabetical order without a score.
   * Once the corporate challenge is in progress the list will
   * become a leaderboard showing which members are winning.
   * The leaderboard is ordered by each member's score.
   */
  members: MembersResponse;
  name: Scalars['String']['output'];
  /** Current user's state within the team */
  userPermissions?: Maybe<TeamPermissions>;
};

export type TeamMembersArgs = {
  pagination: MembersPaginationInput;
};

export enum TeamMembershipPrompt {
  JoinTeam = 'JOIN_TEAM',
  LeaveTeam = 'LEAVE_TEAM',
  None = 'NONE',
}

export type TeamPermissions = {
  __typename: 'TeamPermissions';
  canChangeTeamImage?: Maybe<Scalars['Boolean']['output']>;
  canChangeTeamName?: Maybe<Scalars['Boolean']['output']>;
  canCreateATeam?: Maybe<Scalars['Boolean']['output']>;
  canRemoveTeamImage?: Maybe<Scalars['Boolean']['output']>;
  isTeamAdmin?: Maybe<Scalars['Boolean']['output']>;
  membershipPrompt: TeamMembershipPrompt;
};

export type TeamsLeaderboardEntry = {
  __typename: 'TeamsLeaderboardEntry';
  position?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  /** Extended from team-api */
  team: Team;
};

export enum TextFormat {
  Html = 'HTML',
  Plain = 'PLAIN',
}

export type Tier = {
  __typename: 'Tier';
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  tierModel?: Maybe<Scalars['String']['output']>;
};

export type TierActivity = {
  __typename: 'TierActivity';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  completedAt: Scalars['GraphQLDateTime']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  pointsEarned?: Maybe<Scalars['Int']['output']>;
};

export type TierDefinition = {
  __typename: 'TierDefinition';
  name: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
};

export type TierEncouragement = {
  __typename: 'TierEncouragement';
  iconType?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type TierPointAward = {
  __typename: 'TierPointAward';
  frequency: TierPointFrequencyType;
  points: Scalars['Int']['output'];
};

export enum TierPointFrequencyType {
  Daily = 'Daily',
  Monthly = 'Monthly',
  OneOff = 'OneOff',
  Weekly = 'Weekly',
}

export type TierPoints = {
  __typename: 'TierPoints';
  earned: TierPointsEarned;
  id?: Maybe<Scalars['ID']['output']>;
  remainingToReachNextTier?: Maybe<Scalars['Int']['output']>;
  requiredToNotRegress?: Maybe<TierPointsRequired>;
};

export type TierPointsEarned = {
  __typename: 'TierPointsEarned';
  thisMonth: TierPointsEarnedInTimePeriod;
  total: Scalars['Int']['output'];
};

export type TierPointsEarnedInTimePeriod = {
  __typename: 'TierPointsEarnedInTimePeriod';
  since?: Maybe<Scalars['GraphQLDate']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type TierPointsRequired = {
  __typename: 'TierPointsRequired';
  remaining: Scalars['Int']['output'];
  thisMonth: TierPointsRequiredInTimePeriod;
  total: Scalars['Int']['output'];
};

export type TierPointsRequiredInTimePeriod = {
  __typename: 'TierPointsRequiredInTimePeriod';
  daysRemaining: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  until: Scalars['GraphQLDate']['output'];
  value: Scalars['Int']['output'];
};

export type TierRegressionInfo = {
  __typename: 'TierRegressionInfo';
  currentTierDefinition: TierDefinition;
  image?: Maybe<Image>;
  timePeriods: Array<TierRegressionTimePeriodInfo>;
};

export type TierRegressionTimePeriodInfo = {
  __typename: 'TierRegressionTimePeriodInfo';
  isCurrent?: Maybe<Scalars['Boolean']['output']>;
  pointGoal?: Maybe<Scalars['Int']['output']>;
  pointsEarned?: Maybe<Scalars['Int']['output']>;
  timePeriod?: Maybe<TimePeriod>;
};

export type TierReward = {
  __typename: 'TierReward';
  info: Scalars['String']['output'];
  points: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TimePeriod = {
  __typename: 'TimePeriod';
  from: Scalars['GraphQLDateTime']['output'];
  to: Scalars['GraphQLDateTime']['output'];
};

export type TimeSpan = {
  __typename: 'TimeSpan';
  minutes?: Maybe<Scalars['Int']['output']>;
};

export type TmhWpoAppointmentsHealthCheckResponse = {
  __typename: 'TmhWpoAppointmentsHealthCheckResponse';
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type Tooltip = {
  __typename: 'Tooltip';
  body?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Image>;
  title: Scalars['String']['output'];
  tooltipId: TooltipId;
};

export enum TooltipId {
  EarnPointsPerAssessment = 'EarnPointsPerAssessment',
  HowCanIEarnAssessmentTierPoints = 'HowCanIEarnAssessmentTierPoints',
  JoinCareNow = 'JoinCareNow',
}

export type TotalHealthIndexBracket = {
  __typename: 'TotalHealthIndexBracket';
  bracketId: Scalars['ID']['output'];
  color: Color;
  description?: Maybe<Scalars['String']['output']>;
};

export type TotalHealthIndexCard = {
  __typename: 'TotalHealthIndexCard';
  heroCardId: Scalars['String']['output'];
  nextPillar?: Maybe<AssessmentListItem>;
  score: TotalHealthIndexScore;
  status: AssessmentStatus;
  subtitle: Scalars['String']['output'];
  tierPoints?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type TotalHealthIndexPromotion = {
  __typename: 'TotalHealthIndexPromotion';
  externalId: Scalars['ID']['output'];
  icon?: Maybe<Image>;
  image?: Maybe<Image>;
  message?: Maybe<Scalars['String']['output']>;
  promotionType?: Maybe<PromotionType>;
  schedule?: Maybe<WellbeingPromotionSchedule>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type TotalHealthIndexResult = {
  __typename: 'TotalHealthIndexResult';
  articles?: Maybe<Array<Article>>;
  score: TotalHealthIndexScore;
  subtitle: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TotalHealthIndexScore = {
  __typename: 'TotalHealthIndexScore';
  bracket: TotalHealthIndexBracket;
  percentage: Scalars['Float']['output'];
};

export type Transaction = {
  __typename: 'Transaction';
  cancellation_reason?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source_amount: Scalars['String']['output'];
  source_currency: Scalars['String']['output'];
  source_wallet_id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  target_amount: Scalars['String']['output'];
  target_currency: Scalars['String']['output'];
  target_wallet_id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type UnFavoriteMerchantInput = {
  id: Scalars['ID']['input'];
};

export type UnFavoriteMerchantResponse = {
  __typename: 'UnFavoriteMerchantResponse';
  merchant: Merchant;
};

export type UpdateActivitySourceInput = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  source: ActivitySourceDevice;
};

export type UpdateActivitySourceResponse = {
  __typename: 'UpdateActivitySourceResponse';
  source: ActivitySourceDevice;
};

export type UpdateChallengeTeamNameInput = {
  challengeId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  /** Team name is mandatory when editing team details */
  teamName: Scalars['String']['input'];
};

export type UpdateChallengeTeamResponse = {
  __typename: 'UpdateChallengeTeamResponse';
  /** The updated Team details from the database */
  team: Team;
};

/** Input for updating a conversation. */
export type UpdateConversationInput = {
  /** Whether the conversation is archived. */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** The session ID of the conversation to update. */
  sessionId: Scalars['ID']['input'];
  /** Updated title for the conversation. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Response returned after successfully updating a conversation. */
export type UpdateConversationResponse = {
  __typename: 'UpdateConversationResponse';
  /** Whether the conversation is archived. */
  archived: Scalars['Boolean']['output'];
  /** A confirmation message from the API. */
  message: Scalars['String']['output'];
  /** The title. */
  title: Scalars['String']['output'];
};

export type UpdateGroupChallengeInput = {
  allowManualSteps?: InputMaybe<Scalars['Boolean']['input']>;
  challengeId: Scalars['GraphQLUUID']['input'];
  durationInDays?: InputMaybe<Scalars['Int']['input']>;
  goal?: InputMaybe<Scalars['Int']['input']>;
  /** The url returned by the member image upload. Omit it to keep the current image, or send null to remove it */
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateTime']['input']>;
  targetType?: InputMaybe<TargetType>;
  /** An IANA timezone name, as on create. Sending it recomputes the end date from the same duration in the new zone */
  timezone?: InputMaybe<Scalars['GraphQLTimeZone']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupChallengeResponse = {
  __typename: 'UpdateGroupChallengeResponse';
  challenge?: Maybe<GroupChallenge>;
};

export type UpdateHabitActivityInput = {
  challengeId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  habitId: Scalars['String']['input'];
  habitOptions: Array<UpdateHabitOptionActivityInput>;
};

export type UpdateHabitActivityResponse = {
  __typename: 'UpdateHabitActivityResponse';
  habitDailyActivity?: Maybe<HabitDailyActivity>;
  updatedHabitActivityTotals?: Maybe<UpdatedHabitActivityTotals>;
};

export type UpdateHabitOptionActivityInput = {
  optionId: Scalars['String']['input'];
  tracked: Scalars['Int']['input'];
};

export type UpdatePersonalisationPermissionInput = {
  allowPersonalisation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePersonalisationPermissionResponse = {
  __typename: 'UpdatePersonalisationPermissionResponse';
  permission?: Maybe<HowPersonalisationWorksPermission>;
};

export type UpdatedHabitActivityTotals = {
  __typename: 'UpdatedHabitActivityTotals';
  challengeTrackedActivityTotal: Scalars['Int']['output'];
  habitTrackedActivityTotal: Scalars['Int']['output'];
};

export type UploadExerciseEventsInput = {
  events: Array<InputMaybe<ExerciseEventInput>>;
  source?: InputMaybe<SourceDevice>;
};

export type UploadExerciseEventsResponse = {
  __typename: 'UploadExerciseEventsResponse';
  events: Array<Maybe<ExerciseEvent>>;
};

/**
 * User should ideally live in a more appropriate service
 * and be extended into Challenge Score API and Team API
 */
export type User = {
  __typename: 'User';
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
};

export type UserTeamMembershipResponse = {
  __typename: 'UserTeamMembershipResponse';
  /**
   * If the user is a member of any team in the challenge
   * they cannot create a new team within this challenge
   */
  canCreateATeam: Scalars['Boolean']['output'];
};

export type Walkthrough = {
  __typename: 'Walkthrough';
  steps: Array<WalkthroughStep>;
  wasCompleted: Scalars['Boolean']['output'];
};

export type WalkthroughStep = {
  __typename: 'WalkthroughStep';
  image?: Maybe<Image>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum WalkthroughType {
  CareNow = 'CareNow',
  Wellbeing = 'Wellbeing',
}

export type WalkthroughTypeInput = {
  walkthroughType?: InputMaybe<WalkthroughType>;
};

export type WellbeingContentLanguageBanner =
  | WellbeingContentLanguageMessageChangeLanguage
  | WellbeingContentLanguageMessageNoChoice
  | WellbeingContentLanguageMessageNoContent;

export type WellbeingContentLanguageMessageChangeLanguage = {
  __typename: 'WellbeingContentLanguageMessageChangeLanguage';
  bannerText: Scalars['String']['output'];
  bannerTextPopUp: Scalars['String']['output'];
  section: WellbeingContentLanguageMessageSection;
};

export type WellbeingContentLanguageMessageNoChoice = {
  __typename: 'WellbeingContentLanguageMessageNoChoice';
  bannerText: Scalars['String']['output'];
  bannerTextPopUp: Scalars['String']['output'];
  section: WellbeingContentLanguageMessageSection;
};

export type WellbeingContentLanguageMessageNoContent = {
  __typename: 'WellbeingContentLanguageMessageNoContent';
  bannerText: Scalars['String']['output'];
  section: WellbeingContentLanguageMessageSection;
};

export type WellbeingContentLanguageMessageResponse = {
  __typename: 'WellbeingContentLanguageMessageResponse';
  banner?: Maybe<WellbeingContentLanguageBanner>;
};

export enum WellbeingContentLanguageMessageSection {
  Assessments = 'ASSESSMENTS',
  Programs = 'PROGRAMS',
}

export type WellbeingPromotion =
  | AssessmentPromotion
  | ChallengePromotion
  | HraPromotion
  | TotalHealthIndexPromotion;

export type WellbeingPromotionSchedule = {
  __typename: 'WellbeingPromotionSchedule';
  /** @deprecated Use endDateTime */
  endDate?: Maybe<Scalars['GraphQLDate']['output']>;
  endDateTime?: Maybe<Scalars['GraphQLDateTime']['output']>;
  /** @deprecated Use startDateTime */
  startDate?: Maybe<Scalars['GraphQLDate']['output']>;
  startDateTime?: Maybe<Scalars['GraphQLDateTime']['output']>;
};

export type WorkLifeService = {
  __typename: 'WorkLifeService';
  /** Localized description of the service as a plain text String. */
  description: Scalars['String']['output'];
  /** Image resource for the icon of the service. */
  icon?: Maybe<Image>;
  /** Identifier for the service. */
  id: Scalars['ID']['output'];
  /** Localized name of the service. */
  name: Scalars['String']['output'];
};

export type WorkLifeServicesInput = {
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkLifeServicesResponse = {
  __typename: 'WorkLifeServicesResponse';
  services: PaginatedWorkLifeServices;
};

export type WpoAppointment = {
  __typename: 'WpoAppointment';
  appointmentId: Scalars['ID']['output'];
  appointmentMode: WpoAppointmentType;
  counsellorName: Scalars['String']['output'];
  dateFrom: Scalars['GraphQLDateTime']['output'];
  dateTo: Scalars['GraphQLDateTime']['output'];
  displayDateFrom: Scalars['String']['output'];
  displayDateTo: Scalars['String']['output'];
  isCancelAllowed: Scalars['Boolean']['output'];
  serviceName: Scalars['String']['output'];
  serviceTypeId: Scalars['Int']['output'];
  status: WpoAppointmentStatus;
  thirdPartyVideoJoinLink?: Maybe<Scalars['String']['output']>;
  timeZoneCode: Scalars['String']['output'];
};

export enum WpoAppointmentStatus {
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
}

export enum WpoAppointmentType {
  PhoneCall = 'PHONE_CALL',
  VideoCall = 'VIDEO_CALL',
}

export type WpoAvailableDateTimeSlotsResponse = {
  __typename: 'WpoAvailableDateTimeSlotsResponse';
  availableTimeSlots?: Maybe<Array<WpoAvailableTimeSlot>>;
  wpoFiltersResponse: WpoFiltersResponse;
  wpoServiceConfig: WpoServiceConfig;
};

export type WpoAvailableTimeSlot = {
  __typename: 'WpoAvailableTimeSlot';
  endDateTime: Scalars['GraphQLDateTime']['output'];
  startDateTime: Scalars['GraphQLDateTime']['output'];
  timeslotId: Scalars['ID']['output'];
};

export type WpoCancelAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
};

export type WpoCancelAppointmentResponse = {
  __typename: 'WpoCancelAppointmentResponse';
  success: Scalars['Boolean']['output'];
};

export type WpoCounsellorFilterMapping = {
  __typename: 'WpoCounsellorFilterMapping';
  id: Scalars['ID']['output'];
};

export type WpoCounsellorFilterMappingInput = {
  id: Scalars['ID']['input'];
};

export type WpoCounsellorResponse = {
  __typename: 'WpoCounsellorResponse';
  bio: Scalars['String']['output'];
  counsellorId: Scalars['ID']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  picture?: Maybe<Scalars['String']['output']>;
};

export type WpoCreateAppointmentInput = {
  appointmentMode: WpoAppointmentType;
  counsellorFirstName: Scalars['String']['input'];
  counsellorId: Scalars['ID']['input'];
  counsellorLastName: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  timeslotId: Scalars['ID']['input'];
  wpoFiltersInput: WpoFiltersInput;
  wpoServiceInput: WpoServiceInput;
};

export type WpoCreateAppointmentResponse = {
  __typename: 'WpoCreateAppointmentResponse';
  appointmentEndDateTime: Scalars['GraphQLDateTime']['output'];
  appointmentId: Scalars['Int']['output'];
  appointmentMode: WpoAppointmentType;
  appointmentStartDateTime: Scalars['GraphQLDateTime']['output'];
  counsellorFirstName: Scalars['String']['output'];
  counsellorId: Scalars['Int']['output'];
  counsellorLastName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  userEmail: Scalars['String']['output'];
  userFirstName: Scalars['String']['output'];
  userLastName: Scalars['String']['output'];
};

export type WpoFilter = {
  __typename: 'WpoFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WpoFiltersInput = {
  areaOfConcerns?: InputMaybe<Array<WpoCounsellorFilterMappingInput>>;
  languages?: InputMaybe<Array<WpoCounsellorFilterMappingInput>>;
};

export type WpoFiltersResponse = {
  __typename: 'WpoFiltersResponse';
  areaOfConcerns?: Maybe<Array<WpoCounsellorFilterMapping>>;
  languages?: Maybe<Array<WpoCounsellorFilterMapping>>;
};

export type WpoGetAppointmentHistoryInput = {
  wpoServiceType: WpoServiceType;
};

export type WpoGetAppointmentHistoryResponse = {
  __typename: 'WpoGetAppointmentHistoryResponse';
  appointments: Array<WpoAppointment>;
};

export type WpoGetAvailableCounsellorsInput = {
  emailAddress: Scalars['String']['input'];
  timeslotId: Scalars['ID']['input'];
  wpoFiltersInput: WpoFiltersInput;
  wpoServiceInput: WpoServiceInput;
};

export type WpoGetAvailableCounsellorsResponse = {
  __typename: 'WpoGetAvailableCounsellorsResponse';
  counsellorList?: Maybe<Array<WpoCounsellorResponse>>;
  wpoFiltersResponse: WpoFiltersResponse;
  wpoServiceConfig: WpoServiceConfig;
};

export type WpoGetAvailableTimeSlotsInput = {
  emailAddress: Scalars['String']['input'];
  wpoFiltersInput: WpoFiltersInput;
  wpoServiceInput: WpoServiceInput;
};

export type WpoGetFiltersInput = {
  wpoServiceInput: WpoServiceInput;
};

export type WpoGetFiltersResponse = {
  __typename: 'WpoGetFiltersResponse';
  areaOfConcerns?: Maybe<Array<WpoFilter>>;
  counsellorLanguages?: Maybe<Array<WpoFilter>>;
};

export type WpoGetUpcomingAppointmentInput = {
  /** @deprecated Use wpoServiceType instead */
  wpoServiceInput?: InputMaybe<WpoServiceInput>;
  wpoServiceType?: InputMaybe<WpoServiceType>;
};

export type WpoGetUpcomingAppointmentResponse = {
  __typename: 'WpoGetUpcomingAppointmentResponse';
  appointment: WpoAppointment;
};

export type WpoServiceConfig = {
  __typename: 'WpoServiceConfig';
  appointmentTypeId: Scalars['ID']['output'];
  serviceId: Scalars['ID']['output'];
};

export type WpoServiceInput = {
  appointmentTypeId: Scalars['ID']['input'];
  serviceId: Scalars['ID']['input'];
};

export enum WpoServiceType {
  Counseling = 'COUNSELING',
  PracticalSupport = 'PRACTICAL_SUPPORT',
}

export type WpoUserHasUpcomingAppointment = {
  __typename: 'WpoUserHasUpcomingAppointment';
  appointment: Scalars['Boolean']['output'];
  wpoServiceConfig: WpoServiceConfig;
};

export type WpoUserHasUpcomingAppointmentInput = {
  wpoServiceType: WpoServiceType;
};

export type ChangeGenderInput = {
  answers: Array<AssessmentAnswersInput>;
  gender: Scalars['String']['input'];
  requestGlobalContent?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

export type ChangeGenderResponse = {
  __typename: 'changeGenderResponse';
  assessment?: Maybe<AssessmentListItem>;
};

export type FetchChallengeResponse = {
  __typename: 'fetchChallengeResponse';
  challenge?: Maybe<Challenge>;
};

export type FetchChallengesResponse = {
  __typename: 'fetchChallengesResponse';
  challenges?: Maybe<Array<Challenge>>;
};

export type FetchFeaturedChallengesResponse = {
  __typename: 'fetchFeaturedChallengesResponse';
  challenges?: Maybe<Array<Challenge>>;
};

export type RetakeAssessmentInput = {
  requestGlobalContent?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['ID']['input'];
};

export type RetakeAssessmentResponse = {
  __typename: 'retakeAssessmentResponse';
  assessment?: Maybe<AssessmentListItem>;
};
